<template>
  <div class="app">
    <Loading :value="loading"></Loading>
    <!-- RACOURCIS -->
    <v-card>
      <v-card-title>
        <v-breadcrumbs divider="/">
          <v-breadcrumbs-item icons router
            :to ="item.path"
            v-for="item in items"
            :key="item.text"
            :disabled="item.disabled"
          >
            {{ item.text }}
          </v-breadcrumbs-item>
        </v-breadcrumbs>
      </v-card-title>
    </v-card>
    <br />

    <v-container fluid grid-list-md>
      <div>
        <el-tabs
          v-model="tab1"
          type="border-card"
          @tab-click="handleTabClick1(tab1)"
        >
          <!-- LISTE DES TYPES DE PROJETS -->
          <el-tab-pane>
            <span slot="label">
              <i class="el-icon-tickets"></i> LISTE DES TYPES CHANTIERS
            </span>
            <v-spacer></v-spacer>
            <v-flex xs12>
              <v-layout row class="mb-4 mt-1">
                <v-flex md4 class="mr-1">
                  <el-select
                    @change="filtrerTypeProjet()"
                    filterable
                    clearable
                    v-model="selectSearchTypeProjet"
                    placeholder="Selectionner un Type de chantier"
                    style="width:100%"
                  >
                    <el-option
                      v-for="item in itemsTypeProjet"
                      :key="item.id"
                      :label="item.libelle"
                      :value="item.id"
                    >
                      <span style="float: left">{{
                        item.libelle.toUpperCase()
                      }}</span>
                      <span
                        style="float: right; color: #8492a6; font-size: 13px"
                        >( {{ item.ref }})</span
                      >
                    </el-option>
                  </el-select>
                </v-flex>
              </v-layout>
            </v-flex>

            <!-- <v-layout row> -->
            <div class="text-xs-right">
              <v-layout row>
                <v-flex>
                  <v-tooltip top>
                    <v-btn
                      v-if="droitAcces.new_type_projet"
                      slot="activator"
                      icons
                      color="primary"
                      @click.stop="newTypeProjet()"
                      dark
                      >Ajouter <v-icon right>add</v-icon></v-btn
                    >
                    Ajouter un nouveau type de chantier
                  </v-tooltip>
                </v-flex>
              </v-layout>
            </div>
            <data-tables :data="listTypeProjet" style="width: 100%">
              <!-- <el-table-column prop="ref" label="Référence" fixed="left">
                <template slot-scope="scope">
                  <span class="orange--text title">{{ scope.row.ref }}</span>
                </template>
              </el-table-column> -->
              <el-table-column prop="code" label="Code de type chantier" fixed="left">
                <template slot-scope="scope">
                  <span class="orange--text title">{{ scope.row.code }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="libelle" label="Libellé">
                <template slot-scope="scope">
                  <el-tag class="body-2">{{ scope.row.libelle }}</el-tag>
                </template>
              </el-table-column>
              <el-table-column label="Action" fixed="right">
                <template slot-scope="scope">
                  <div class="text-xs-center">
                    <v-tooltip top>
                      <v-btn
                        v-if="droitAcces.show_type_projet"
                        slot="activator"
                        @click.stop="showTypeProjet(scope.row)"
                        fab
                        dark
                        small
                        color="green"
                      >
                        <v-icon dark>folder_open</v-icon>
                      </v-btn>
                      Détails
                    </v-tooltip>
                    <v-tooltip v-if="droitAcces.edit_type_projet" top>
                      <v-btn
                        slot="activator"
                        @click="editTypeProjet(scope.row)"
                        fab
                        dark
                        small
                        color="primary"
                      >
                        <v-icon dark>edit</v-icon>
                      </v-btn>
                      Modifier
                    </v-tooltip>
                    <v-tooltip top>
                      <v-btn
                        slot="activator"
                        @click.stop="
                          dialogSuprTyp = true;
                          idAppro = scope.row.id;
                        "
                        fab
                        dark
                        small
                        color="red"
                      >
                        <v-icon dark>delete</v-icon>
                      </v-btn>
                      Supprimer
                    </v-tooltip>
                  </div>
                </template>
              </el-table-column>
            </data-tables>
            <!-- </v-layout> -->
          </el-tab-pane>

          <!-- LISTE DES TRAVAUX -->
          <el-tab-pane>
            <span slot="label">
              <i class="el-icon-tickets"></i> LISTE DES LOTS
            </span>
            <v-spacer></v-spacer>
            <data-tables :data="listeProjetTravaux">
              <el-table-column type="expand">
                <template slot-scope="props">
                  <v-layout
                    wrap
                    class="elevation-4 pt-4 pb-4 pr-4 pl-4 grey lighten-4"
                  >
                    <v-flex xs12>
                      <span class="title">Liste des travaux</span>
                      <v-divider class="mt-4"></v-divider>
                      <v-layout row>
                        <v-flex xs12 class="mr-2 mt-3">
                          <div class="grid-content">
                            <v-flex xs12>
                              <v-layout row wrap>
                                <v-flex xs12>
                                  <el-table
                                    :row-class-name="tableRowClassName"
                                    :data="props.row.listeTypeTravaux"
                                    stripe
                                    style="width: 100%"
                                  >
                                    <el-table-column
                                      prop="ordre"
                                      label="Ordre"
                                      sortable
                                    >
                                      <template slot-scope="scope">
                                        <span class="subheading">{{
                                          scope.row.ordre
                                        }}</span>
                                      </template>
                                    </el-table-column>
                                     <el-table-column
                                      prop="code"
                                      label="Code"
                                      sortable
                                    >
                                      <template slot-scope="scope">
                                        <span class="grey--text title">{{
                                          scope.row.code
                                        }}</span>
                                      </template>
                                    </el-table-column>
                                    <el-table-column
                                      prop="libelle"
                                      label="Libellé"
                                      sortable
                                    >
                                      <template slot-scope="scope">
                                        <span class="green--text subheading">{{
                                          scope.row.libelle
                                        }}</span>
                                      </template>
                                    </el-table-column>

                                      <el-table-column label="Action" fixed="right">
                                        <template slot-scope="scope">
                                            <div class="text-xs-center">
                                          <v-tooltip top>
                                              <v-btn v-if="droitAcces.show_travaux" slot="activator" @click.stop="showTravaux(scope.row)" flat dark small color="green">
                                                  Détails
                                              </v-btn>
                                              Détails
                                          </v-tooltip>
                                          <v-tooltip top>
                                              <v-btn v-if="droitAcces.show_travaux" slot="activator" @click.stop="editType(scope.row,'travaux')" flat dark small color="primary">
                                                  Modifier
                                              </v-btn>
                                              Modifier
                                          </v-tooltip>
                                        </div>
                                        </template>
                                      </el-table-column>
                                  </el-table>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </div>
                        </v-flex>
                      </v-layout>
                    </v-flex>
                  </v-layout>
                </template>
              </el-table-column>
              <el-table-column prop="reference" label="Référence" sortable>
                <template slot-scope="scope">
                  <span class="orange--text title">{{
                    scope.row.reference
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="type" label="Type chantier" sortable>
                <template slot-scope="scope">
                  <el-tag class="body-2">
                    {{ scope.row.libelle }}
                  </el-tag>
                </template>
              </el-table-column>
               <el-table-column label="Action" fixed="right">
                <template slot-scope="scope">
                  <div class="text-xs-center">
                    <v-tooltip top>
                      <v-btn
                        slot="activator"
                        @click.stop="newTravaux(scope.row)"
                        fab
                        dark
                        small
                        color="primary"
                      >
                        <v-icon dark>add</v-icon>
                      </v-btn>
                     Ajouter/Modifier un lot de travaux
                    </v-tooltip>
                      <v-tooltip top>
                      <v-btn
                        slot="activator"
                         @click.stop="duplicateTravaux(scope.row)"
                        fab
                        dark
                        small
                        color="orange"
                      >
                        <v-icon dark>content_copy</v-icon>
                      </v-btn>
                       Dupliquer les travaux
                    </v-tooltip>
                  </div>
                </template>
              </el-table-column>
            </data-tables>
          </el-tab-pane>

          <!--LISTE DES TÂCHES-->
          <el-tab-pane>
            <span slot="label">
              <i class="el-icon-tickets"></i> LISTE DES TÂCHES
            </span>
            <v-spacer></v-spacer>

            <data-tables :data="listeTacheTravaux">
              <el-table-column type="expand">
                <template slot-scope="props">
                  <v-layout
                    wrap
                    class="elevation-4 pt-4 pb-4 pr-4 pl-4 grey lighten-4"
                  >
                    <v-flex xs12>
                      <span class="title">Liste des travaux </span>
                      <v-divider class="mt-4"></v-divider>
                      <v-layout row>
                        <v-flex xs12 class="mr-2 mt-3">
                          <div class="grid-content">
                            <v-flex xs12>
                              <v-layout row wrap>
                                <v-flex xs12>
                                    <el-table
                                      :row-class-name="tableRowClassName"
                                      :data="props.row.listeTypeTravaux"
                                      stripe
                                      style="width: 100%"
                                    >                                  
                                      
                                              <el-table-column type="expand">                                              
                                                    <template slot-scope="props">
                                                      <div v-if="props.row.nbSous > 0">
                                                          <v-layout wrap class="elevation-4 pt-4 pb-4 pr-4 pl-4 grey lighten-4">
                                                          <v-flex xs12>
                                                          <span class="title">Liste des sous sections</span>
                                                          <v-divider class="mt-4"></v-divider>
                                                          <v-layout row>
                                                            <v-flex xs12 class="mr-2 mt-3">
                                                              <div class="grid-content">
                                                                <v-flex xs12>
                                                                  <v-layout row wrap>
                                                                    <v-flex xs12>
                                                                      <el-table
                                                                        :row-class-name="tableRowClassName"
                                                                        :data="props.row.sous"
                                                                        stripe
                                                                        style="width: 100%"
                                                                      >
                                                                        <el-table-column type="expand">
                                                                          <template slot-scope="props">
                                                                            <v-layout
                                                                              wrap
                                                                              class="elevation-4 pt-4 pb-4 pr-4 pl-4 grey lighten-4"
                                                                            >
                                                                              <v-flex xs12>
                                                                                <span class="title"
                                                                                  >Liste des tâches</span
                                                                                >
                                                                                <v-divider class="mt-4"></v-divider>
                                                                                <v-layout row>
                                                                                  <v-flex xs12 class="mr-2 mt-3">
                                                                                    <div class="grid-content">
                                                                                      <v-flex xs12>
                                                                                        <v-layout row wrap>
                                                                                          <v-flex xs12>
                                                                                            <el-table
                                                                                              :row-class-name="
                                                                                                tableRowClassName
                                                                                              "
                                                                                              :data="
                                                                                                props.row
                                                                                                  .listeTypeTache
                                                                                              "
                                                                                              stripe
                                                                                              style="width: 100%"
                                                                                            >
                                                                                              <el-table-column
                                                                                                prop="ordre"
                                                                                                label="Ordre"
                                                                                                sortable
                                                                                              >
                                                                                                <template
                                                                                                  slot-scope="scope"
                                                                                                >
                                                                                                  <span
                                                                                                    class="subheading"
                                                                                                    >{{
                                                                                                      scope.row
                                                                                                        .ordre
                                                                                                    }}</span
                                                                                                  >
                                                                                                </template>
                                                                                              </el-table-column>

                                                                                              <el-table-column
                                                                                                prop="libelle"
                                                                                                label="Libellé"
                                                                                                sortable
                                                                                              >
                                                                                                <template
                                                                                                  slot-scope="scope"
                                                                                                >
                                                                                                  <span
                                                                                                    class="green--text subheading"
                                                                                                    >{{
                                                                                                      scope.row
                                                                                                        .libelle
                                                                                                    }}</span
                                                                                                  >
                                                                                                </template>
                                                                                              </el-table-column>

                                                                                              <el-table-column
                                                                                                prop="unite"
                                                                                                label="unite"
                                                                                              >
                                                                                                <template
                                                                                                  slot-scope="scope"
                                                                                                >
                                                                                                  <span
                                                                                                    class="grey--text title"
                                                                                                    >{{
                                                                                                      scope.row
                                                                                                        .unite
                                                                                                    }}</span
                                                                                                  >
                                                                                                </template>
                                                                                              </el-table-column>

                                                                                              <el-table-column
                                                                                                prop="prix"
                                                                                                label="prix (FCFA)"
                                                                                              >
                                                                                                <template
                                                                                                  slot-scope="scope"
                                                                                                >
                                                                                                  <span
                                                                                                    class="grey--text title"
                                                                                                    >{{
                                                                                                      new Intl.NumberFormat(
                                                                                                        "fr-FR"
                                                                                                      ).format(
                                                                                                        scope.row
                                                                                                          .prix
                                                                                                      )
                                                                                                    }}</span
                                                                                                  >
                                                                                                </template>
                                                                                              </el-table-column>

                                                                                              <el-table-column
                                                                                                label="Action"
                                                                                              >
                                                                                                <template slot-scope="scope">
                                                                                                  <div class="text-xs-center">
                                                                                                    <v-tooltip top>
                                                                                                        <v-btn slot="activator" @click.stop="showTravaux(scope.row)" flat dark small color="green">
                                                                                                            Détails
                                                                                                        </v-btn>
                                                                                                        Détails
                                                                                                    </v-tooltip>
                                                                                                  </div>
                                                                                                </template>
                                                                                              </el-table-column>
                                                                                            </el-table>
                                                                                          </v-flex>
                                                                                        </v-layout>
                                                                                                </v-flex>
                                                                                              </div>
                                                                                            </v-flex>
                                                                                          </v-layout>
                                                                                        </v-flex>
                                                                                      </v-layout>
                                                                                    </template>
                                                                                  </el-table-column>
                                                                                  <el-table-column prop="ordre" label="Ordre">
                                                                                    <template slot-scope="scope">
                                                                                      <span class="subheading">{{scope.row.ordre}}</span>
                                                                                    </template>
                                                                                  </el-table-column>
                                                                                  
                                                                                  <el-table-column
                                                                                    prop="code"
                                                                                    label="Code"
                                                                                    sortable
                                                                                  >
                                                                                    <template slot-scope="scope">
                                                                                      <span class="grey--text title">{{
                                                                                        scope.row.code
                                                                                      }} </span>
                                                                                    </template>
                                                                                  </el-table-column>

                                                                                  <el-table-column
                                                                                    prop="libelle"
                                                                                    label="Libellé"
                                                                                    sortable
                                                                                  >
                                                                                    <template slot-scope="scope">
                                                                                      <span class="green--text subheading">{{
                                                                                        scope.row.libelle
                                                                                      }}</span>
                                                                                    </template>
                                                                                  </el-table-column>

                                                                                  <el-table-column label="Action">
                                                                                    <template slot-scope="scope">                                                                           
                                                                                      <div class="text-xs-center">
                                                                                        <v-tooltip top>
                                                                                            <v-btn v-if="droitAcces.show_travaux" slot="activator" @click.stop="showTravaux(scope.row)" flat dark small color="green">
                                                                                                Détails
                                                                                            </v-btn>
                                                                                            Détails
                                                                                        </v-tooltip>
                                                                                      </div>

                                                                                        <div class="text-xs-center">
                                                                                          <v-tooltip top>
                                                                                              <v-btn slot="activator" @click.stop="newTache(scope.row,'niveau')" flat dark small color="primary">
                                                                                                  Ajouter
                                                                                              </v-btn>
                                                                                              Ajouter/Modifier un lot de tache
                                                                                          </v-tooltip>
                                                                                      </div>

                                                                                      <div class="text-xs-center" v-if="scope.row.nbSous === 0">
                                                                                          <v-tooltip top>
                                                                                              <v-btn slot="activator"  @click.stop="duplicateTaches(scope.row,props.row)" flat dark small color="orange">
                                                                                                  Dupliquer
                                                                                              </v-btn>
                                                                                              Dupliquer les tâches
                                                                                          </v-tooltip>
                                                                                      </div>
                                                                                    </template>
                                                                                  </el-table-column>
                                                                                </el-table>
                                                                              </v-flex>
                                                                            </v-layout>
                                                                          </v-flex>
                                                                        </div>
                                                                      </v-flex>
                                                            </v-layout>
                                                          </v-flex>
                                                        </v-layout>
                                                      </div>

                                                      <!--autre condition  -->
                                                        <div v-else>
                                                        <v-layout
                                                        wrap
                                                        class="elevation-4 pt-4 pb-4 pr-4 pl-4 grey lighten-4"
                                                      >
                                                        <v-flex xs12>
                                                          <span class="title"
                                                            >Liste des tâches </span
                                                          >
                                                          <v-divider class="mt-4"></v-divider>
                                                          <v-layout row>
                                                            <v-flex xs12 class="mr-2 mt-3">
                                                              <div class="grid-content">
                                                                <v-flex xs12>
                                                                  <v-layout row wrap>
                                                                    <v-flex xs12>
                                                                      <el-table
                                                                        :row-class-name="tableRowClassName"
                                                                        :data="props.row.listeTypeTache"
                                                                        stripe
                                                                        style="width: 100%"
                                                                      >
                                                                        <el-table-column
                                                                          prop="ordre"
                                                                          label="Ordre"
                                                                          sortable
                                                                        >
                                                                          <template
                                                                            slot-scope="scope"
                                                                          >
                                                                            <span
                                                                              class="subheading"
                                                                              >{{
                                                                                scope.row
                                                                                  .ordre
                                                                              }}</span
                                                                            >
                                                                          </template>
                                                                        </el-table-column>

                                                                        <el-table-column
                                                                          prop="libelle"
                                                                          label="Libellé"
                                                                          sortable
                                                                        >
                                                                          <template
                                                                            slot-scope="scope"
                                                                          >
                                                                            <span
                                                                              class="green--text subheading"
                                                                              >{{
                                                                                scope.row
                                                                                  .libelle
                                                                              }}</span
                                                                            >
                                                                          </template>
                                                                        </el-table-column>

                                                                        <el-table-column
                                                                          prop="unite"
                                                                          label="unite"
                                                                        >
                                                                          <template
                                                                            slot-scope="scope"
                                                                          >
                                                                            <span
                                                                              class="grey--text title"
                                                                              >{{
                                                                                scope.row
                                                                                  .unite
                                                                              }}</span
                                                                            >
                                                                          </template>
                                                                        </el-table-column>

                                                                        <el-table-column
                                                                          prop="prix"
                                                                          label="prix (FCFA)"
                                                                        >
                                                                          <template
                                                                            slot-scope="scope"
                                                                          >
                                                                            <span
                                                                              class="grey--text title"
                                                                              >{{
                                                                                new Intl.NumberFormat(
                                                                                  "fr-FR"
                                                                                ).format(
                                                                                  scope.row
                                                                                    .prix
                                                                                )
                                                                              }}</span
                                                                            >
                                                                          </template>
                                                                        </el-table-column>

                                                                        <el-table-column
                                                                          label="Action"
                                                                        >
                                                                          <template
                                                                            slot-scope="scope"
                                                                          >
                                                                            <div class="text-xs-center">
                                                                              <v-tooltip top>
                                                                                  <v-btn slot="activator" @click.stop="showTravaux(scope.row)" flat dark small color="green">
                                                                                      Détails
                                                                                  </v-btn>
                                                                                  Détails
                                                                              </v-tooltip>
                                                                            </div>
                                                                          </template>
                                                                        </el-table-column>
                                                                      </el-table>
                                                                    </v-flex>
                                                                  </v-layout>
                                                                </v-flex>
                                                              </div>
                                                            </v-flex>
                                                          </v-layout>
                                                        </v-flex>
                                                        </v-layout>
                                                        </div>
                                                      <!-- fin autre condition -->

                                                    </template>                                                                                       
                                              </el-table-column>

                                              <el-table-column prop="ordre" label="Ordre">
                                                <template slot-scope="scope">
                                                  <span class="subheading">{{scope.row.ordre }}</span>
                                                </template>
                                              </el-table-column>

                                              <el-table-column
                                                prop="code"
                                                label="Code"
                                                sortable
                                              >
                                                <template slot-scope="scope">
                                                  <span class="grey--text title">{{
                                                    scope.row.code
                                                  }}</span>
                                                </template>
                                              </el-table-column>
                                              <el-table-column
                                                prop="libelle"
                                                label="Libellé"
                                                sortable
                                              >
                                                <template slot-scope="scope">
                                                  <span class="green--text subheading">{{
                                                    scope.row.libelle 
                                                  }}</span>
                                                </template>
                                              </el-table-column>
                                          
                                              <el-table-column label="Action">
                                                <template slot-scope="scope"> 
                                                  <div class="text-xs-center" v-if="scope.row.nbSous == 0 && scope.row.sous.length == 0 && scope.row.listeTypeTache.length == 0">
                                                      <v-tooltip top>
                                                          <v-btn slot="activator" @click.stop="newNiveau(scope.row)" flat dark small color="primary">
                                                              Ajouter un niveau
                                                          </v-btn>
                                                          Ajouter/Editer un niveau
                                                      </v-tooltip>
                                                  </div>

                                                  <div class="text-xs-center">
                                                    <v-tooltip top>
                                                        <v-btn v-if="droitAcces.show_travaux" slot="activator" @click.stop="showTravaux(scope.row)" flat dark small color="green">
                                                       Détails
                                                        </v-btn>
                                                        Détails
                                                    </v-tooltip>
                                                  </div>

                                                    <div class="text-xs-center" v-if="scope.row.nbSous > 0">
                                                      <v-tooltip top>
                                                          <v-btn slot="activator" @click.stop="newNiveau(scope.row)" flat dark small color="primary">
                                                              Editer
                                                          </v-btn>
                                                          Ajouter/Editer la sous section
                                                      </v-tooltip>
                                                  </div>

                                                   <div class="text-xs-center" v-if="scope.row.nbSous == 0 ">
                                                      <v-tooltip top>
                                                          <v-btn slot="activator" @click.stop="newTache(scope.row)" flat dark small color="primary">
                                                              Ajouter
                                                          </v-btn>
                                                          Ajouter/Modifier un lot de tache
                                                      </v-tooltip>
                                                  </div>

                                                  <div class="text-xs-center"  v-if="scope.row.nbSous == 0">
                                                      <v-tooltip top>
                                                          <v-btn slot="activator"  @click.stop="duplicateTaches(scope.row,props.row)" flat dark small color="orange">
                                                              Dupliquer
                                                          </v-btn>
                                                          Dupliquer les tâches
                                                      </v-tooltip>
                                                  </div>
                                                </template>
                                              </el-table-column>
                                    </el-table>
                                </v-flex>
                                </v-layout>
                              </v-flex>
                            </div>
                          </v-flex>
                      </v-layout>
                    </v-flex>
                    </v-layout>
                  </template>
               </el-table-column>

              <el-table-column prop="reference" label="Référence" sortable>
                <template slot-scope="scope">
                  <span class="orange--text title">{{
                    scope.row.reference
                  }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="type" label="Type chantier" sortable>
                <template slot-scope="scope">
                  <el-tag class="body-2">
                    {{ scope.row.libelle }}
                  </el-tag>
                </template>
              </el-table-column>
            </data-tables>
          </el-tab-pane>
          <!-- FIN LISTE DES TÂCHES-->

          <!-- LISTE DES CATEGORIES DE RESSOURCES -->
          <el-tab-pane>
            <span slot="label">
              <i class="el-icon-tickets"></i> LISTE DES CATEGORIES DE RESSOURCES
            </span>
            <v-spacer></v-spacer>         

            <!-- <v-layout row> -->
            <div class="text-xs-right">
              <v-layout row>
                <v-flex>
                  <v-tooltip top>
                    <v-btn                    
                      slot="activator"
                      icons
                      color="primary"
                      @click.stop="newTypeRessource()"
                      dark
                      >Ajouter <v-icon right>add</v-icon></v-btn
                    >
                    Ajouter/Editer un nouveau type de ressource
                  </v-tooltip>
                </v-flex>
              </v-layout>
            </div>

            <data-tables :data="listTypeRessource" style="width: 100%">             
            <!-- <el-table-column prop="id" label="Identifiant">
                <template slot-scope="scope">
                  <el-tag class="body-2">ID-{{ scope.row.id }}</el-tag>
                </template>
              </el-table-column> -->
              <el-table-column prop="code" label="Code">
                <template slot-scope="scope">
                  <el-tag class="body-2">{{ scope.row.code }}</el-tag>
                </template>
              </el-table-column>
              <el-table-column prop="libelle" label="Libellé">
                <template slot-scope="scope">
                  <el-tag class="body-2">{{ scope.row.libelle }}</el-tag>
                </template>
              </el-table-column>            
              <el-table-column label="Action" fixed="right">
                <template slot-scope="scope">
                  <div class="text-xs-center">
                    <v-tooltip top>
                      <v-btn                        
                        slot="activator"
                        @click.stop="showTypeRessource(scope.row)"
                        fab
                        dark
                        small
                        color="green"
                      >
                        <v-icon dark>folder_open</v-icon>
                      </v-btn>
                      Détails
                    </v-tooltip>
                    <v-tooltip top>
                      <v-btn
                        slot="activator"
                        @click="editTypeRessource(scope.row)"
                        fab
                        dark
                        small
                        color="primary"
                      >
                        <v-icon dark>edit</v-icon>
                      </v-btn>
                      Modifier
                    </v-tooltip>                  
                  </div>
                </template>
              </el-table-column>
            </data-tables>
            <!-- </v-layout> -->
          </el-tab-pane>

          <!--LISTE DES PRODUITS-->
          <el-tab-pane v-if="droitAcces.product_list">
            <span slot="label">
              <i class="el-icon-tickets"></i> LISTE DES RESSOURCES
            </span>
            <v-spacer></v-spacer>
            <v-flex xs12>
              <v-layout row class="mb-4 mt-1">
                <v-flex md4 class="mr-1">
                  <!-- <span class="demonstration">Type produit *</span> -->
                  <el-select
                    name="valeurSelect"
                    clearable
                    id="valeurSelect"
                    v-model="IdTypeSelct"
                    filterable
                    v-on:change="loadTypeProduit()"
                    placeholder="Sélectionner un type ressource"
                    style="width:100%"
                  >
                    <el-option
                      v-for="item in listTypeRessource"
                      :key="item.id"
                      :label="item.libelle"
                      :value="item.libelle"
                    >
                    </el-option>
                  </el-select>
                </v-flex>

                <v-flex md4 class="mr-1">
                  <el-select
                    v-model="IdProduiSelect"
                    clearable
                    filterable
                    @clear="clearSelectProduit()"
                    @change="filtrerEtatPrioriteBesoin"
                    placeholder="Sélectionner une ressource"
                    style="width:100%"
                  >
                    <el-option
                      v-for="item in listeProduitAffich"
                      :key="item.id"
                      :label="item.libelle"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </v-flex>
              </v-layout>
            </v-flex>
            <div class="text-xs-right">
              <v-layout row>
                <v-flex>
                  <v-tooltip top>
                    <v-btn
                      v-if="droitAcces.index_type_tache && droitAcces.create_new_product"
                      slot="activator"
                      icons
                      color="primary"
                      @click.stop="newProduit()"
                      dark
                      >Ajouter <v-icon right>add</v-icon></v-btn
                    >
                    Ajouter une nouvelle ressource
                  </v-tooltip>
                </v-flex>
              </v-layout>
            </div>
             <v-flex xs12 class="text-xs-right" v-if="droitAcces.index_type_tache && droitAcces.create_new_product">
                  <v-tooltip top>
                        <input
                          name="fileInputExcel"
                          type="file"
                          style="display:none"
                          ref="fileInputExcel"
                          accept="image/*"
                          v-on:change="onFileExcelPicked"
                        />
                        <v-btn
                            v-if="true"
                            slot="activator"
                            color="green"
                            @click.stop="$refs.fileInputExcel.click()"
                            dark
                        >
                            Importer
                            <v-icon right>file_download</v-icon>
                        </v-btn>Importer fichier excel
                  </v-tooltip>

                    <v-tooltip top>
                  <v-btn
                      v-if="true"
                      slot="activator"
                      color="orange"
                      @click.stop="generateFileExcel()"
                      dark
                  >
                      Générer
                      <v-icon right>file_upload</v-icon>
                  </v-btn>Générer un modèle
                  </v-tooltip>
              </v-flex>
            <br />
            <data-tables :data="listeProduitAffich" style="width: 100%">
               <el-table-column
                prop="value"
                label="Code gestion"
                fixed="left"
                sortable
              >
                <template slot-scope="scope">
                  <v-chip text-color="white" label color="indigo">
                    {{ scope.row.codeGestion }}
                  </v-chip>
                </template>
              </el-table-column>
               <el-table-column
                prop="codeAnalytique"
                label="Code Analytique"
                fixed="left"
                sortable
              >
                <template slot-scope="scope">
                  <v-chip text-color="white" label color="green">
                    {{ scope.row.codeAnalytique }}
                  </v-chip>
                </template>
              </el-table-column>
              <el-table-column
                prop="value"
                label="Référence/Libellé"
                fixed="left"
                sortable
              >
                <template slot-scope="scope">
                  <v-chip text-color="white" label color="primary">
                    {{ scope.row.reference }}
                  </v-chip>
                  <v-chip outline text-color="primary" label color="primary">
                    {{ scope.row.value }}
                  </v-chip>
                </template>
              </el-table-column>
              <el-table-column prop="type" label="Type" sortable>
                <template slot-scope="scope">
                  <v-chip outline text-color="orange" label color="orange">
                    {{ scope.row.type }}
                  </v-chip>
                </template>
              </el-table-column>
              <el-table-column
                prop="valeur"
                label="Prix de (vente ou d'utilisation) (FCFA)"
              >
                <template slot-scope="scope" style="cente r">
                  <v-chip outline text-color="indigo" label color="indigo">
                    {{
                      new Intl.NumberFormat("fr-FR").format(scope.row.valeur)
                    }}
                    <v-icon right>money</v-icon>
                  </v-chip>
                </template>
              </el-table-column>
                <el-table-column prop="unite" label="Unite" sortable>
                <template slot-scope="scope">
                  <v-chip outline text-color="orange" label color="orange">
                    {{ scope.row.unite }}
                  </v-chip>
                </template>
              </el-table-column>
              <el-table-column label="Action" fixed="right">
                <template slot-scope="scope">
                  <div class="text-xs-center">
                    <v-tooltip top>
                      <v-btn
                        slot="activator"
                        @click.stop="
                        tab = '0';
                        showProduit(scope.row)"
                        fab
                        dark
                        small
                        color="green"
                      >
                        <v-icon dark>folder_open</v-icon>
                      </v-btn>
                      Détails
                    </v-tooltip>
                    <v-tooltip top>
                      <v-btn
                        slot="activator"
                        @click="editProduit(scope.row)"
                        fab
                        dark
                        small
                        color="primary"
                      >
                        <v-icon dark>edit</v-icon>
                      </v-btn>
                      Modifier
                    </v-tooltip>
                    <v-tooltip top>
                      <v-btn
                        slot="activator"
                        @click.stop="
                          dialogSuprProd = true;
                          idAppro = scope.row.id;
                        "
                        fab
                        dark
                        small
                        color="red"
                      >
                        <v-icon dark>delete</v-icon>
                      </v-btn>
                      Supprimer
                    </v-tooltip>
                  </div>
                </template>
              </el-table-column>
            </data-tables>
          </el-tab-pane>
          <!-- FIN LISTE DES PRODUITS-->
        </el-tabs>
      </div>
    </v-container>

    <!-- MODAL SUPPRESSION CATEGORIE -->
    <v-dialog
      v-model="dialogSuprCategorie"
      max-width="50%"
      :overlay="true"
      scrollable
      persistent
    >
      <v-card>
        <v-card-text text-xs-center>
          <h6 align="center">
            Voulez-vous vraiment supprimer cette categorie ?
          </h6>
          <p align="center">
            <v-btn
              @click.native="dialogSuprCategorie = false"
              color="orange"
              dark
              >Annuler <v-icon right>remove_circle</v-icon></v-btn
            >
            <v-btn icons color="red" @click.stop="deleteCategory" dark
              >Supprimer <v-icon right>delete</v-icon></v-btn
            >
          </p>
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- MODAL SUPPRESSION KEYWORD -->
    <v-dialog
      v-model="dialogSuprKeyword"
      max-width="50%"
      :overlay="true"
      scrollable
      persistent
    >
      <v-card>
        <v-card-text text-xs-center>
          <h6 align="center">Voulez-vous vraiment supprimer ce mot cle ?</h6>
          <p align="center">
            <v-btn @click.native="dialogSuprKeyword = false" color="orange" dark
              >Annuler <v-icon right>remove_circle</v-icon></v-btn
            >
            <v-btn icons color="red" @click.stop="deleteKeyword" dark
              >Supprimer <v-icon right>delete</v-icon></v-btn
            >
          </p>
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- MODAL DELETE LEXIQUE -->
    <v-dialog
      v-model="dialogSuprLexique"
      max-width="50%"
      :overlay="true"
      scrollable
      persistent
    >
      <v-card>
        <v-card-text text-xs-center>
          <h6 align="center">Voulez-vous vraiment supprimer ce champ ?</h6>
          <p align="center">
            <v-btn @click.native="dialogSuprLexique = false" color="orange" dark
              >Annuler <v-icon right>remove_circle</v-icon></v-btn
            >
            <v-btn icons color="red" @click.stop="deleteLexique" dark
              >Supprimer <v-icon right>delete</v-icon></v-btn
            >
          </p>
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>


    <!-- MODAL SUPPRESSION TARIFICATION -->
  <v-dialog v-model="dialogSupTarif" max-width="50%" :overlay="true" scrollable persistent>
    <v-card>
      <v-card-text text-xs-center>
        <h1 align="center">Voulez-vous vraiment supprimer "{{selectProduit }}" de la tarification chez {{tarifCourant.fourn}} ?</h1>
        <p align="center">
          <v-btn @click.native="dialogSupTarif = false" color="orange" dark>Annuler <v-icon right>remove_circle</v-icon></v-btn>
          <v-btn icons color="red" @click.stop="deleteTarification" dark>Supprimer <v-icon right>delete</v-icon></v-btn>
        </p>
      </v-card-text>
      <div style="flex: 1 1 auto;"></div>
    </v-card>
  </v-dialog>


    <!-- MODAL ADD CATEGORY -->
    <v-dialog
      v-model="dialogAjoutCategory"
      max-width="50%"
      :overlay="true"
      scrollable
      persistent
    >
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="blue">
          <v-toolbar-title>
            <span>Ajouter une nouvelle categorie</span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogAjoutCategory = false" dark
            ><v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <v-form
            v-model="valid"
            ref="formCategorie"
            lazy-validation
            id="formCategorie"
          >
            <v-container fluid grid-list-md>
              <v-layout row justify>
                <v-flex md6>
                  <v-text-field
                    label="Libelle"
                    name="libelleCategorie"
                    v-model="libelleCategorie"
                    required
                  ></v-text-field>
                </v-flex>
                <v-flex md6>
                  <v-textarea
                    label="Description"
                    name="descCategorie"
                    v-model="descCategorie"
                    multi-line
                    required
                  ></v-textarea>
                </v-flex>
              </v-layout>
            </v-container>

            <v-btn @click="dialogAjoutCategory = false" color="orange" dark
              >Annuler <v-icon right>remove_circle</v-icon></v-btn
            >
            <v-btn
              icons
              color="blue"
              @click="addCategorie"
              :disabled="!valid"
              dark
              >Enregistrer <v-icon right>save</v-icon></v-btn
            >
          </v-form>
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- MODAL ADD PRODUIT -->
    <v-dialog
      v-model="dialogAjoutProduit"
      max-width="85%"
      :overlay="true"
      scrollable
      persistent
    >
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="blue">
          <v-toolbar-title>
            <span v-if="dialogEditProduit !== true"
              >Ajouter une nouvelle ressource</span
            >
            <span v-if="dialogEditProduit">Modifier la ressource</span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogAjoutProduit = false" dark
            ><v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text v-loading="loading">
          <v-form
            v-model="valid"
            ref="formProduit"
            lazy-validation
            id="formProduit"
          >
            <v-container fluid grid-list-md>
              <v-layout row>
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Catégorie de ressource *</span>
                    <el-select
                      v-model="typeProduit"
                      filterable
                      v-on:change="SelectionTypePrdotuit(typeProduit)"
                      placeholder="Catégorie ressource"
                      style="width:100%"
                    >
                      <el-option
                        v-for="item in listTypeRessource"
                        :key="item.id"
                        :label="item.libelle"
                        :value="item.libelle"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </v-flex> 
                <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Code catégorie *</span>
                    <el-input
                        name="codeType"
                        disabled
                        v-model="codeType"
                      ></el-input>
                  </div>
                </v-flex>                
              </v-layout>
              <v-layout row v-if="dialogEditProduit != true">
                <v-flex md11>
                  <p align="center">
                    <v-chip
                      outline
                      text-color="primary"
                      label
                      color="primary"
                      style="width:100%"
                    >
                      AJOUTER LES LIGNES DE PRODUITS
                    </v-chip>
                  </p>
                </v-flex>
              </v-layout>

              <el-form
                label-position="top"
                :inline="true"
                :model="formTypeProduit"
                class="demo-form-inline"
              >
                <v-layout row>
                  <v-flex md4>
                  <span class="demonstration">Code article</span>
                    <el-select clearable allow-create filterable v-model="codeGestion" placeholder="Code article" style="width:100%">
                        <el-option v-for="item in listcodeGestion" :key="item.id" :label="item.libelle" :value="item.id">
                        </el-option>
                    </el-select>
                 </v-flex>
                 <v-flex md4>
                  <span class="demonstration">Code analytique</span>
                  <el-input
                        name="codeAnalytique"
                        placeholder="Code anlytique"
                        v-model="formTypeProduit.codeAnalytique"
                      ></el-input>
                 </v-flex>
                  <v-flex md4>
                    <div class="block">
                      <span class="demonstration">Référence</span>
                      <el-input
                        name="referenceProduit"
                        placeholder="Reference"
                        v-model="formTypeProduit.referenceProduit"
                      ></el-input>
                    </div>
                  </v-flex>
                  <v-flex md4>
                    <div class="block">
                      <span class="demonstration">Libellé *</span>
                      <el-input
                        name="libelleProduit"
                        placeholder="Libelle"
                        v-model="formTypeProduit.libelleProduit"
                        class="upper"
                      ></el-input>
                    </div>
                  </v-flex>
                </v-layout>
                <v-layout row>

                  <v-flex md4>
                    <div class="block">
                      <span class="demonstration"
                        >Prix de (vente ou d'utilisation)(FCFA) *</span
                      >
                      <el-input
                        type="number"
                        name="valeurProduit"
                        placeholder="Prix de vente ou d'utilisation"
                        v-model="formTypeProduit.valeurProduit"
                      ></el-input>
                    </div>
                  </v-flex>

                  <v-flex md4>
                    <div class="block">
                      <span class="demonstration">Unité * </span>
                      <el-input
                        name="libelleUnite"
                        placeholder="Unité"
                        v-model="formTypeProduit.libelleUnite"
                        class="upper"
                      ></el-input>
                    </div>
                  </v-flex>

                  <v-flex md4>
                    <div class="block">
                      <span class="demonstration">Description</span>
                      <el-input
                        name="descProduit"
                        type="textarea"
                        :rows="3"
                        v-model="formTypeProduit.descProduit"
                        style="width: 100%"
                      ></el-input>
                    </div>
                  </v-flex>
                </v-layout>
                <v-flex md1> </v-flex>
              </el-form>
             <v-flex xs12 class="text-xs-right">
              <v-btn
                icons
                color="primary"
                v-if="dialogEditProduit != true && this.tableTypeProduit.length != 5"
                id="plus"
                @click="addListProduit(formTypeProduit)"
                fab
                small
                dark
              >
                <v-icon>add</v-icon></v-btn
              >
              </v-flex>

              <!-- <v-btn icons color="primary"  v-if="dialogEditProduit !== true"  id="plus" @click="addListTypeProduit(formTypeProduit)" fab small dark> <v-icon>add</v-icon></v-btn> -->

              <v-layout row v-if="dialogEditProduit !== true">
                <el-table :data="tableTypeProduit" style="width: 100%">
                  <el-table-column
                    v-for="column in tachesTypeProduit"
                    :key="column.id"
                    :prop="column.prop"
                    :label="column.label"
                    sortable
                  >
                  </el-table-column>
                  <el-table-column label="Operations">
                    <template slot-scope="scope">
                      <v-tooltip top>
                        <v-btn
                          slot="activator"
                          fab
                          small
                          icons
                          color="red"
                          @click.native.prevent="
                            deleteTypeProduit(scope.$index, tableTypeProduit)
                          "
                          dark
                        >
                          <v-icon center>delete</v-icon>
                        </v-btn>
                        Supprimer cette ressource
                      </v-tooltip>
                    </template>
                  </el-table-column>
                </el-table>
              </v-layout>
            </v-container>

            <v-btn @click="dialogAjoutProduit = false" color="orange" dark
              >Annuler <v-icon right>remove_circle</v-icon></v-btn
            >
            <v-btn
              icons
              color="blue"
              @click="addProduit"
              :disabled="!valid"
              dark
              >Enregistrer <v-icon right>save</v-icon></v-btn
            >
          </v-form>
        </v-card-text>


        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>


    <!-- MODAL ADD TACHE -->
    <v-dialog
      v-model="dialogAjoutTache"
      max-width="90%"
      :overlay="true"
      scrollable
      persistent
    >
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="blue">
          <v-toolbar-title>
            <span v-if="dialogEdit !== true">Ajouter une nouvelle tâche </span>
            <span v-if="dialogEdit"
              >Modifier la tâche {{ tacheCourant.libelle }}
            </span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogAjoutTache = false" dark
            ><v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text v-loading="loading">
          <v-form
            v-model="valid"
            ref="formTache"
            lazy-validation
            id="formTache"
          >
            <v-container fluid grid-list-md>
              <v-layout row>
                <v-flex md6>
                  <div class="block">
                    <span class="demonstration">Type de projet </span>
                    <el-select
                      filterable
                      v-on:change="loadTravaux()"
                      v-model="typeProjet"
                      placeholder="Type de projet"
                      style="width:100%"
                    >
                      <el-option
                        v-for="item in listTypeProjet"
                        :key="item.id"
                        :label="item.libelle"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </v-flex>
                <v-flex md6>
                  <div class="block">
                    <span class="demonstration">Travaux *</span>
                    <el-select
                      filterable
                      v-model="travaux"
                      placeholder="Travaux"
                      style="width:100%"
                    >
                      <el-option
                        v-for="item in listTravaux"
                        :key="item.id"
                        :label="item.libelle"
                        :value="item.id"
                      >
                      </el-option>
                    </el-select>
                  </div>
                </v-flex>
              </v-layout>
              <v-layout row v-if="dialogEdit !== true">
                <v-flex md11>
                  <p align="center">
                    <v-chip
                      outline
                      text-color="primary"
                      label
                      color="primary"
                      style="width:100%"
                    >
                      AJOUTER LES LIGNES DES TACHES
                    </v-chip>
                  </p>
                </v-flex>
              </v-layout>

              <el-form
                label-position="top"
                :inline="true"
                :model="formTache"
                class="demo-form-inline"
              >
                <v-layout row>
                  <v-flex md3>
                    <div class="block">
                      <span class="demonstration">Libellé tâche*</span>
                      <el-input
                        name="libelle"
                        placeholder="Libellé tâche"
                        v-model="formTache.libelle"
                        style="width:100%"
                        class="upper"
                      ></el-input>
                    </div>
                  </v-flex>
                  <v-flex md2>
                    <div class="block">
                      <span class="demonstration">Ordre d'éxécution</span>
                      <el-input
                        type="number"
                        :value="1"
                        id="ordreTache"
                        name="ordre"
                        :min="1"
                        placeholder="Ordre"
                        v-model="formTache.ordre"
                        style="width:100%"
                      ></el-input>
                    </div>
                  </v-flex>

                  <v-flex md2>
                    <div class="block">
                      <span class="demonstration">Unite </span>
                      <el-input
                        name="unite"
                        placeholder="Unite"
                        v-model="formTache.unite"
                        style="width:100%"
                      ></el-input>
                    </div>
                  </v-flex>

                  <v-flex md4>
                    <div class="block">
                      <span class="demonstration">Prix unitaire HT </span>
                      <el-input-number
                        :min="0"
                        name="prix"
                        placeholder="prix unitaire"
                        v-model="formTache.prix"
                        style="width:100%"
                      ></el-input-number>
                    </div>
                  </v-flex>

                  <v-flex md4>
                    <div class="block">
                      <span class="demonstration">Description</span>
                      <el-input
                        type="textarea"
                        name="description"
                        placeholder="Description"
                        v-model="formTache.description"
                        style="width:100%"
                      ></el-input>
                    </div>
                  </v-flex>
                </v-layout>
                <v-flex md1> </v-flex>
              </el-form>
              <v-btn
                icons
                color="primary"
                v-if="dialogEdit !== true"
                id="plus"
                @click="addListTaches(formTache)"
                fab
                small
                dark
              >
                <v-icon>add</v-icon></v-btn
              >
              <br />

              <v-layout row v-if="dialogEdit !== true">
                <el-table :data="tableTaches" style="width: 100%">
                  <el-table-column
                    v-for="column in taches"
                    :key="column.id"
                    :prop="column.prop"
                    :label="column.label"
                    sortable
                  >
                  </el-table-column>
                  <el-table-column label="Operations">
                    <template slot-scope="scope">
                      <v-tooltip top>
                        <v-btn
                          slot="activator"
                          fab
                          small
                          icons
                          color="red"
                          @click.native.prevent="
                            deleteTache(scope.$index, tableTaches)
                          "
                          dark
                        >
                          <v-icon center>delete</v-icon>
                        </v-btn>
                        Supprimer ce lot
                      </v-tooltip>
                    </template>
                  </el-table-column>
                </el-table>
              </v-layout>
              <br />
            </v-container>

            <v-btn @click="dialogAjoutTache = false" color="orange" dark
              >Annuler <v-icon right>remove_circle</v-icon></v-btn
            >
            <v-btn
              icons
              color="blue"
              @click="submitTache"
              :disabled="!valid"
              dark
              >Enregistrer <v-icon right>save</v-icon></v-btn
            >
          </v-form>
        </v-card-text>

        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- MODAL ADD TRAVAUX -->
    <v-dialog
      v-model="dialogAjoutTravaux"
      max-width="80%"
      :overlay="true"
      scrollable
      persistent
    >
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="blue">
          <v-toolbar-title>
            <span v-if="dialogEdit !== true">Ajouter des nouveaux lots </span>
            <span v-if="dialogEdit"
              >Modifier les lots {{ travauxCourant.libelle }}
            </span>
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogAjoutTravaux = false" dark
            ><v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text v-loading="loading">
          <v-card>
            <v-form
              v-model="valid"
              ref="formTravaux"
              lazy-validation
              id="formTravaux"
            >
              <v-container fluid grid-list-md>
                <v-layout row>
                  <v-flex md6>
                    <div class="block">
                      <span class="demonstration">Type de projet </span>
                      <el-select
                        v-if="dialogEdit == false"
                        v-model="typeProjet"
                        placeholder="Type de projet"
                        style="width:100%"
                      >
                        <el-option
                          v-for="item in listTypeProjet"
                          :key="item.id"
                          :label="item.libelle"
                          :value="item.id"
                        >
                        </el-option>
                      </el-select>
                      <el-input
                        v-if="dialogEdit"
                        v-model="travauxCourant.type"
                        style="width:100%"
                        :readonly="true"
                      ></el-input>
                    </div>
                  </v-flex>
                </v-layout>

                <v-layout row v-if="dialogEdit !== true">
                  <v-flex md11>
                    <p align="center">
                      <v-chip
                        outline
                        text-color="primary"
                        label
                        color="primary"
                        style="width:100%"
                      >
                        AJOUTER LES LIGNES DE LOTS
                      </v-chip>
                    </p>
                  </v-flex>
                </v-layout>

                <el-form
                  label-position="top"
                  :inline="true"
                  :model="formTravaux"
                  class="demo-form-inline"
                >
                  <v-layout row>
                    <v-flex md3>
                      <div class="block">
                        <span class="demonstration">Libelle lot *</span>
                        <el-input
                          name="libelle"
                          placeholder="Libellé lot"
                          v-model="formTravaux.libelle"
                          style="width:100%"
                          class="upper"
                        ></el-input>
                      </div>
                    </v-flex>
                    <v-flex md2>
                      <div class="block">
                        <span class="demonstration">Ordre d'éxécution</span>
                        <el-input
                          type="number"
                          :value="1"
                          id="ordre"
                          name="ordre"
                          :min="1"
                          placeholder="ordre"
                          v-model="formTravaux.ordre"
                          style="width:100%"
                        ></el-input>
                      </div>
                    </v-flex>

                    <v-flex md2>
                      <div class="block">
                        <span class="demonstration">Code </span>
                        <el-input
                          name="code"
                          placeholder="code lot"
                          v-model="formTravaux.code"
                          style="width:100%"
                        ></el-input>
                      </div>
                    </v-flex>

                    <v-flex md6>
                      <div class="block">
                        <span class="demonstration">Description</span>
                        <el-input
                          type="textarea"
                          name="description"
                          placeholder="Description"
                          v-model="formTravaux.description"
                          style="width:100%"
                        ></el-input>
                      </div>
                    </v-flex>
                  </v-layout>
                  <v-flex md1> </v-flex>
                </el-form>
                <v-btn
                  icons
                  color="primary"
                  v-if="dialogEdit !== true"
                  id="plus"
                  @click="addListParticipantDemande(formTravaux)"
                  fab
                  small
                  dark
                >
                  <v-icon>add</v-icon></v-btn
                >
                <br />

                <v-layout row v-if="dialogEdit !== true">
                  <el-table :data="tableLots" style="width: 100%">
                    <el-table-column
                      v-for="column in columns"
                      :key="column.id"
                      :prop="column.prop"
                      :label="column.label"
                      sortable
                    >
                    </el-table-column>
                    <el-table-column label="Operations">
                      <template slot-scope="scope">
                        <v-tooltip top>
                          <v-btn
                            slot="activator"
                            fab
                            small
                            icons
                            color="red"
                            @click.native.prevent="
                              deleteRow(scope.$index, tableLots)
                            "
                            dark
                          >
                            <v-icon center>delete</v-icon>
                          </v-btn>
                          Supprimer ce lot
                        </v-tooltip>
                      </template>
                    </el-table-column>
                  </el-table>
                </v-layout>
                <br />
              </v-container>

              <v-btn @click="dialogAjoutTravaux = false" color="orange" dark
                >Annuler <v-icon right>remove_circle</v-icon></v-btn
              >
              <v-btn
                icons
                color="blue"
                @click="submitTravaux()"
                :disabled="!valid"
                dark
                >Enregistrer <v-icon right>save</v-icon></v-btn
              >
            </v-form>
          </v-card>
        </v-card-text>

        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- MODAL SHOW CATEGORIE -->
    <v-dialog
      v-model="dialogShowCategorie"
      max-width="50%"
      :overlay="true"
      scrollable
      persistent
    >
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="blue">
          <v-toolbar-title>Détails de la catégorie </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogShowCategorie = false" dark
            ><v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <el-row :gutter="20">
            <el-col :span="20">
              <div class="grid-content bg-purple">
                <el-card class="box-card" style="background:#F9FAFC">
                  <div slot="header" class="carte-header">
                    <v-flex text-xs-center layout align-center justify-center>
                    </v-flex>
                  </div>
                  <div class="text item">
                    <p><b>Libellé : </b> {{ currentCategorie.libelle }}</p>
                    <p>
                      <b>Description : </b> {{ currentCategorie.description }}
                    </p>
                    <p>
                      <b>Date d'enregistrement :</b>
                      {{ currentCategorie.created }}
                    </p>
                    <p>
                      <b>Date de modification :</b>
                      {{ currentCategorie.modified }}
                    </p>
                  </div>
                </el-card>
              </div>
            </el-col>
          </el-row>
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- MODAL SHOW KEYWORD -->
    <v-dialog
      persistent
      v-model="dialogShowProduit"
      max-width="90%"
      :overlay="false"
      scrollable
    >
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="primary">
          <v-toolbar-title
            >Détails de la ressource {{ currentProduit.value }}</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-btn icon @click.native="closeShowProdui()" dark>
            <v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>
        <v-card-text>
          <v-container fluid grid-list-md>
            <!-- MODAL MAP GOOGLE -->
            <v-expansion-panel>
              <v-expansion-panel-content class="blue lighten-4 elevation-18">
                <div slot="header">
                  CLIQUEZ POUR AFFICHER LES DETAILS DE LA RESSOURCE
                  <i class="el-icon-tickets"></i>
                </div>
               <v-card-text>
          <el-row :gutter="20">
            <div class="grid-content bg-purple">
              <el-card class="box-card" style="background:#F9FAFC">
                <div class="text item">
                  <v-layout row wrap>
                      <v-flex md4>
                        <p><b>Type : </b> {{ currentProduit.type }}</p>
                        <p><b>Code article : </b> {{ currentProduit.codeGestion }}</p>

                        <p><b>Réference : </b> {{ currentProduit.ref }}</p>
                      <p>
                        <b>Prix de (vente ou d'utilisation) (FCFA) : </b>
                        {{
                          new Intl.NumberFormat("fr-FR").format(
                            currentProduit.valeur
                          )
                        }}
                      </p>
                      <p><b>Unité : </b> {{ currentProduit.unite }}</p>
                      </v-flex>
                      <v-flex md4>
                        <p>
                        <b>Description : </b> {{ currentProduit.description }}
                      </p>
                      <p>
                        <b>Date d'enregistrement :</b>
                        {{ currentProduit.created }}
                      </p>
                      <p>
                        <b>Date de modification :</b>
                        {{ currentProduit.modified }}
                      </p>
                        <p>
                        <b>Modifié par :</b>
                        {{ currentProduit.userModified }}
                      </p>
                      </v-flex>
                       <v-flex md4>
                        <p>
                             <b>Taux d'utilisation</b>
                          </p>
                          <v-progress-circular
                                  :size="100"
                                  :width="30"
                                  :rotate="360"
                                  :value="currentProduit.evolution"
                                  color="red"
                          >{{currentProduit.evolutionNbr}} %</v-progress-circular>
                      </v-flex>
                    </v-layout>
                  </div>
                </el-card>
              </div>
            </el-row>
          </v-card-text>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <!-- MODAL MAP GOOGLE  -->
            <br />

            <div>
              <el-tabs
                v-model="tab"
                type="border-card"
                @tab-click="TabClick(tab)"
              >
                <!-- DETAIL PROJET -->
                <el-tab-pane>
                  <span slot="label">
                    <i class="el-icon-list"></i> PRIX FOURNISSEURS
                  </span>
                  <v-layout row wrap justify>
                     <v-layout mb-2 >
                          <v-flex sm12 >
                            <v-flex  class="text-xs-center">
                                  <v-card class="elevation-5" style="height:350px">
                                    <h4>Statistiques fournisseurs</h4>
                                    <v-divider class="mb-1"></v-divider>
                                    <div class="mb-2" id="chartFactureAnFour" style="width: 100%; height:100%">
                                    </div>
                                </v-card>
                              </v-flex>
                          </v-flex>
                      </v-layout>
                    <v-flex xs12>
                      <v-expansion-panel focusable popout value="0">
                        <v-expansion-panel-content>
                          <template v-slot:header>
                            <div>
                            <v-chip color="orange" text-color="white" style="font-size:18px">
                                    <v-avatar  class="orange darken-4"> {{listeProduitFourn.length}} </v-avatar>
                                    Fournisseur(s) trouvé(s)
                                  </v-chip>
                          </div>
                          </template>
                          <v-card>
                            <v-card-text class="grey lighten-5">
                               <data-tables :data="listeProduitFourn" style="width: 100%">
                                    <el-table-column
                                      prop="value"
                                      label="REF FOURNISSEUR	"
                                      fixed="left"
                                      sortable
                                    >
                                      <template slot-scope="scope">
                                        <v-chip text-color="white" label color="indigo">
                                          {{ scope.row.ref }}
                                        </v-chip>
                                      </template>
                                    </el-table-column>
                                    <el-table-column
                                      prop="value"
                                      label="FOURNISSEUR"
                                      fixed="left"
                                      sortable
                                    >
                                      <template slot-scope="scope">
                                        <v-chip text-color="white" label color="primary">
                                          {{ scope.row.fourn }}
                                        </v-chip>
                                      </template>
                                    </el-table-column>
                                    <el-table-column
                                      prop="valeur"
                                      label="PRIX UNITAIRE HT"
                                    >
                                      <template slot-scope="scope" style="cente r">
                                        <v-chip outline text-color="indigo" label color="indigo">
                                          {{
                                            new Intl.NumberFormat("fr-FR").format(scope.row.prix)
                                          }}
                                          <v-icon right>money</v-icon>
                                        </v-chip>
                                      </template>
                                    </el-table-column>
                                      <el-table-column prop="prixOld" label="Ancien prix" sortable>
                                      <template slot-scope="scope">
                                        <v-chip outline text-color="orange" label color="orange">
                                          {{ scope.row.prixOld }}
                                        </v-chip>
                                      </template>
                                    </el-table-column>
                                    <el-table-column prop="unite" label="Unite" sortable>
                                      <template slot-scope="scope">
                                        <v-chip outline text-color="orange" label color="orange">
                                          {{ scope.row.unite }}
                                        </v-chip>
                                      </template>
                                    </el-table-column>
                                    <el-table-column prop="userCreated" label="Crée par" sortable>
                                      <template slot-scope="scope">
                                        <v-chip outline text-color="orange" label color="orange">
                                          {{ scope.row.userCreated }}
                                        </v-chip>
                                        <v-chip outline text-color="orange" label color="indigo">
                                         {{ scope.row.created ?  scope.row.created : '' }}
                                        </v-chip>
                                      </template>
                                    </el-table-column>
                                     <el-table-column prop="userCreated" label="Modifier par" sortable>
                                      <template slot-scope="scope">
                                        <v-chip outline text-color="orange" label color="orange">
                                          {{ scope.row.userUpdate }}
                                        </v-chip>
                                        <v-chip outline text-color="orange" label color="orange">
                                          {{ scope.row.modified }}
                                        </v-chip>
                                      </template>
                                    </el-table-column>
                                    <el-table-column label="Action" fixed="right">
                                      <template slot-scope="scope">
                                        <div class="text-xs-center">
                                          <v-tooltip top>
                                            <v-btn
                                              slot="activator"
                                              @click="editTarif(scope.row)"
                                              fab
                                              dark
                                              small
                                              color="primary"
                                            >
                                              <v-icon dark>edit</v-icon>
                                            </v-btn>
                                            Modifier
                                          </v-tooltip>
                                          <v-tooltip top>
                                            <v-btn
                                              slot="activator"
                                              @click.stop="deleteTarif(scope.row)"
                                              fab
                                              dark
                                              small
                                              color="red"
                                            >
                                              <v-icon dark>delete</v-icon>
                                            </v-btn>
                                            Supprimer
                                          </v-tooltip>
                                        </div>
                                      </template>
                                    </el-table-column>
                                  </data-tables>
                            </v-card-text>
                          </v-card>
                          <!-- DASHBOARD PROJET -->
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-flex>
                  </v-layout>
                </el-tab-pane>

                <!-- COMMANDES -->
                <el-tab-pane>
                  <span slot="label">
                    <i class="el-icon-menu"></i> COMMANDES LIEES A LA RESSOURCE
                  </span>
                  <v-spacer></v-spacer>
                  <v-layout row wrap justify>
                     <v-layout mb-2 >
                          <v-flex sm12 >
                            <v-flex  class="text-xs-center">
                                  <v-card class="elevation-5" style="height:350px">
                                    <h4>Statistiques commandes</h4>
                                    <v-divider class="mb-1"></v-divider>
                                    <div class="mb-2" id="chartCommFour" style="width: 100%; height:100%">
                                    </div>
                                </v-card>
                              </v-flex>
                          </v-flex>
                      </v-layout>
                    <v-flex xs12>
                      <v-expansion-panel focusable popout value="1">
                        <v-expansion-panel-content>
                          <template v-slot:header>
                            <div>
                            <v-chip color="orange" text-color="white" style="font-size:18px">
                                    <v-avatar  class="orange darken-4"> {{listeCommandeFourn.length}} </v-avatar>
                                    Commande(s) trouvée(s)
                                  </v-chip>
                          </div>
                          </template>
                          <v-card>
                            <v-card-text class="grey lighten-5">
                               <data-tables :data="listeCommandeFourn" style="width: 100%">
                                 <el-table-column
                                      prop="idProj"
                                      label="ID PROJ"
                                      fixed="left"
                                      sortable
                                    >
                                      <template slot-scope="scope">
                                        <v-chip text-color="white" label color="indigo">
                                          {{ scope.row.idProj }}
                                        </v-chip>
                                      </template>
                                    </el-table-column>
                                    <el-table-column
                                      prop="ref"
                                      label="REF COMMANDE"
                                      fixed="left"
                                      sortable
                                    >
                                      <template slot-scope="scope">
                                        <v-chip text-color="white" label color="indigo">
                                          {{ scope.row.ref }}
                                        </v-chip>
                                      </template>
                                    </el-table-column>
                                    <el-table-column
                                      prop="projet"
                                      label="PROJET"
                                      fixed="left"
                                      sortable
                                    >
                                      <template slot-scope="scope">
                                        <v-chip text-color="white" label color="orange">
                                          {{ scope.row.projet }}
                                        </v-chip>
                                      </template>
                                    </el-table-column>
                                    <el-table-column
                                      prop="value"
                                      label="FOURNISSEUR"
                                      fixed="left"
                                      sortable
                                    >
                                      <template slot-scope="scope">
                                        <v-chip text-color="white" label color="primary">
                                          {{ scope.row.fournisseurNom }}
                                        </v-chip>
                                      </template>
                                    </el-table-column>
                                      <el-table-column prop="qte" label="QUANTITE COMMANDEE" sortable>
                                      <template slot-scope="scope">
                                        <v-chip outline text-color="orange" label color="orange">
                                          {{ scope.row.qte }}
                                        </v-chip>
                                      </template>
                                    </el-table-column>
                                    <el-table-column
                                      prop="valeur"
                                      label="PRIX UNITAIRE HT"
                                    >
                                      <template slot-scope="scope" style="center">
                                        <v-chip outline text-color="indigo" label color="indigo">
                                          {{
                                            new Intl.NumberFormat("fr-FR").format(scope.row.prix)
                                          }}
                                          <v-icon right>money</v-icon>
                                        </v-chip>
                                      </template>
                                    </el-table-column>
                                    <el-table-column prop="unite" label="UNITE" sortable>
                                      <template slot-scope="scope">
                                        <v-chip outline text-color="orange" label color="orange">
                                          {{ scope.row.unite }}
                                        </v-chip>
                                      </template>
                                    </el-table-column>
                                    <el-table-column prop="unite" label="TOTAL TTC" sortable>
                                      <template slot-scope="scope">
                                        <v-chip outline text-color="orange" label color="orange">
                                          {{ scope.row.total }}
                                        </v-chip>
                                      </template>
                                    </el-table-column>
                                    <el-table-column prop="userCreated" label="ENREGISTRER PAR" sortable>
                                      <template slot-scope="scope">
                                        <v-chip outline text-color="orange" label color="orange">
                                          {{ scope.row.userCreated }}
                                        </v-chip>
                                        <v-chip outline text-color="orange" label color="indigo">
                                         {{ scope.row.created ?  scope.row.created : '' }}
                                        </v-chip>
                                      </template>
                                    </el-table-column>
                                      <el-table-column prop="compare" label="COMPARATEUR" >
                                      <template v-if="scope.row.compare == 2" slot-scope="scope">
                                          <a href="#" >
                                              <v-avatar  :tile="true" size="50px" height="50px" color="grey lighten-4"> <img src="static/validComparateur.png" ></v-avatar>
                                          </a>
                                      </template>
                                  </el-table-column>
                                  </data-tables>
                            </v-card-text>
                          </v-card>
                          <!-- DASHBOARD PROJET -->
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-flex>
                  </v-layout>
                </el-tab-pane>

                <!-- STOCKS ENTREPOT-->
                <el-tab-pane>
                  <span slot="label">
                    <v-icon right>shopping_cart</v-icon> STOCKS ENTREPOT
                  </span>
                     <v-layout row wrap justify>
                        <v-layout mb-2 >
                          <v-flex sm12 >
                            <v-flex  class="text-xs-center">
                                  <v-card class="elevation-5" style="height:350px">
                                    <h4>Statistiques stocks</h4>
                                    <v-divider class="mb-1"></v-divider>
                                    <div class="mb-2" id="chartStockProd" style="width: 100%; height:100%">
                                    </div>
                                </v-card>
                              </v-flex>
                          </v-flex>
                      </v-layout>
                    <v-flex xs12>
                      <v-expansion-panel focusable popout value="2">
                        <v-expansion-panel-content>
                          <template v-slot:header>
                            <div>
                            <v-chip color="orange" text-color="white" style="font-size:18px">
                                    <v-avatar  class="orange darken-4"> {{listeStokProd.length}} </v-avatar>
                                    Entrepot(s) trouvé(s)
                                  </v-chip>
                          </div>
                          </template>
                          <v-card>
                            <v-card-text class="grey lighten-5">
                               <data-tables :data="listeStokProd" style="width: 100%">
                                    <el-table-column
                                      prop="value"
                                      label="ENTREPOT"
                                      fixed="left"
                                      sortable
                                    >
                                      <template slot-scope="scope">
                                        <v-chip text-color="white" label color="primary">
                                          {{ scope.row.entrepot }}
                                        </v-chip>
                                      </template>
                                    </el-table-column>
                                    <el-table-column prop="ville" label="Localisation">
                                      <template slot-scope="scope">
                                        <v-chip text-color="white" label color="primary">
                                          {{scope.row.ville }} - {{scope.row.commune }} - {{scope.row.quartier }}<v-icon right>location_on</v-icon>
                                        </v-chip>
                                      </template>
                                    </el-table-column>
                                      <el-table-column prop="qte" label="QUANTITE DISPONIBLE" sortable>
                                      <template slot-scope="scope">
                                        <v-chip outline text-color="orange" label color="orange">
                                          {{ scope.row.qte }}
                                        </v-chip>
                                      </template>
                                    </el-table-column>
                                    <el-table-column prop="unite" label="UNITE" sortable>
                                      <template slot-scope="scope">
                                        <v-chip outline text-color="orange" label color="orange">
                                          {{ scope.row.unite }}
                                        </v-chip>
                                      </template>
                                    </el-table-column>
                                    <el-table-column prop="userCreated" label="DATE AJOUT" sortable>
                                      <template slot-scope="scope">
                                        <v-chip outline text-color="orange" label color="indigo">
                                         {{ scope.row.created ?  scope.row.created : '' }}
                                        </v-chip>
                                      </template>
                                    </el-table-column>
                                  </data-tables>
                            </v-card-text>
                          </v-card>
                        </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-flex>
                      <!-- <v-flex xs12>
                      <v-expansion-panel focusable popout value="2">
                          <v-expansion-panel-content>
                          <template v-slot:header>
                            <div>
                            <v-chip color="indigo" text-color="white" style="font-size:18px">
                                Historique des enlèvements
                            </v-chip>
                          </div>
                          </template>
                          <v-card>
                            <v-card-text class="grey lighten-5">
                               <data-tables :data="listeStokEnlev" style="width: 100%">
                                    <el-table-column
                                      prop="value"
                                      label="ENTREPOT"
                                      fixed="left"
                                      sortable
                                    >
                                      <template slot-scope="scope">
                                        <v-chip text-color="white" label color="primary">
                                          {{ scope.row.entrepot }}
                                        </v-chip>
                                      </template>
                                    </el-table-column>
                                      <el-table-column prop="qte" label="QUANTITE" sortable>
                                      <template slot-scope="scope">
                                        <v-chip outline text-color="orange" label color="orange">
                                          {{ scope.row.qte }}
                                        </v-chip>
                                      </template>
                                    </el-table-column>
                                    <el-table-column prop="unite" label="DATE DE SORTIE" sortable>
                                      <template slot-scope="scope">
                                        <v-chip outline text-color="orange" label color="orange">
                                          {{ scope.row.unite }}
                                        </v-chip>
                                      </template>
                                    </el-table-column>
                                    <el-table-column prop="userCreated" label="DATE DE RETOUR" sortable>
                                      <template slot-scope="scope">
                                        <v-chip outline text-color="orange" label color="indigo">
                                         {{ scope.row.created ?  scope.row.created : '' }}
                                        </v-chip>
                                      </template>
                                    </el-table-column>
                                  </data-tables>
                            </v-card-text>
                          </v-card>
                        </v-expansion-panel-content>
                      </v-expansion-panel>
                    </v-flex> -->
                  </v-layout>
                </el-tab-pane>

                 <!-- STATISTIQUE-->
                <!-- <el-tab-pane>
                  <span slot="label">
                    <v-icon right>shopping_cart</v-icon> STATISTIQUES DE QUANTITES DE PRODUITS
                  </span>
                    <v-flex md3>
                  <div class="block">
                    <span class="demonstration">Année: </span>
                    <el-date-picker
                                format="yyyy"
                                v-model="selecAnne"
                                placeholder="Selectionner une Année"
                                type="year"
                        >
                        </el-date-picker>
                         <v-tooltip bottom>
                            <v-btn @click="loadStatistique(selecAnne)" slot="activator" class="white--text" color="blue" fab small :disabled="selecAnne ==''">
                                <v-icon>search</v-icon>
                            </v-btn>Effectuer une recherche
                        </v-tooltip>
                  </div>

                </v-flex>

                     <v-layout row wrap justify>
                        <v-flex xs12>
                          <v-expansion-panel focusable popout value="3">
                            <v-layout row>
                              <v-flex mr-2 xs12>
                                  <v-layout mb-2 >
                                    <v-flex xs12 class="mb-2 mr-1">
                                        <v-card color="cyan darken-2" class="white--text elevation-5">
                                            <v-container fluid grid-list-lg>
                                                <v-layout row>
                                                    <v-flex xs5>
                                                        <div>
                                                            <div class="headline">
                                                                <v-icon dark>assignment</v-icon>
                                                                {{totalQteCommande}}
                                                            </div>
                                                            <div>Quantité totale Commandée</div>
                                                        </div>
                                                    </v-flex>
                                                    <v-flex xs7>
                                                        <div>Montant total Facturé</div>
                                                        <div class="display-3">{{totalCommande}}</div>
                                                    </v-flex>
                                                </v-layout>
                                            </v-container>
                                        </v-card>
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                                    <v-flex mr-2 xs12>
                                  <v-layout mb-2 >
                                      <v-flex sm12 >
                                        <v-flex  class="text-xs-center">
                                              <v-card class="elevation-5" style="height:350px">
                                                <h4>statistique fournisseurs</h4>
                                                <v-divider class="mb-1"></v-divider>
                                                <div class="mb-2" id="chartFactureAnFour" style="width: 100%; height:100%">
                                                </div>
                                            </v-card>
                                          </v-flex>
                                      </v-flex>
                                  </v-layout>
                                </v-flex>
                            </v-layout>
                          </v-expansion-panel>
                        </v-flex>
                    </v-layout>
                </el-tab-pane> -->
              </el-tabs>
            </div>
          </v-container>
          <v-flex xs12 class="text-xs-right">
            <v-tooltip top>
              <v-btn
                slot="activator"
                icons
                color="orange"
                @click.stop="dialogShowProduit = false"
                dark
              >
                Fermer
                <v-icon right>close</v-icon> </v-btn
              >Fermer
            </v-tooltip>
            <v-tooltip top>
              <v-btn
                slot="activator"
                icons
                color="primary"
                v-if="droitAcces.new_projet"
                @click.stop="editProduit(currentProduit)"
                dark
              >
                Modifer
                <v-icon right>edit</v-icon> </v-btn
              >Modifier
            </v-tooltip>
            </v-flex>
          </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>


    <!-- MODAL NEW TARIFICATION -->
    <v-dialog v-model="dialogTarif" max-width="50%" :overlay="true" scrollable persistent>
        <v-card>
            <v-toolbar style="flex: 0 0 auto;" dark class="blue">
                <v-toolbar-title>
                    <span>Modifier la tarification chez le fournisseur {{tarifCourant.fourn}}</span>
                </v-toolbar-title>

                <v-spacer></v-spacer>
                <v-btn icon @click.native="dialogTarif = false" dark><v-icon>close</v-icon> </v-btn>
            </v-toolbar>

            <v-card-text>
                <v-form v-model="valid" ref="formTarif" lazy-validation id="formTarif">
                    <v-container fluid grid-list-md>
                        <v-layout row>
                              <v-flex md6>
                                <div class="block">
                                    <span class="demonstration">Unité *</span>
                                    <el-input type="text" name="valeurSelect" :readonly="true" v-model="valeurUniteMateriel" style="width:100%"></el-input>
                                </div>
                            </v-flex>
                            <v-flex md6>
                                <div class="block">
                                    <span class="demonstration">Prix d'achat *</span>
                                    <el-input type="number" name="prixAchat" :min="0" placeholder="Prix d'achat" v-model="prixAchat" style="width:100%"></el-input>
                                </div>
                            </v-flex>
                        </v-layout>
                        <br>
                    </v-container>
                    <v-flex xs12 class="text-xs-right">
                      <v-btn @click="dialogTarif = false" color="orange" dark>Annuler <v-icon right>remove_circle</v-icon></v-btn>
                      <v-btn icons color="blue" @click="dialogConfirm = true" dark>Enregistrer <v-icon right>save</v-icon></v-btn>
                    </v-flex>

                </v-form>

                <br>
            </v-card-text>
            <div style="flex: 1 1 auto;"></div>
        </v-card>
    </v-dialog>


      <!-- MODAL confirmation -->
    <v-dialog v-model="dialogConfirm" max-width="50%" :overlay="true" scrollable persistent>
      <v-card>
        <v-card-text text-xs-center>
          <h2 align="center">La modification sera prise en compte pour les nouvelles commandes</h2>
          <p align="center">
            <v-btn @click.native="dialogTarif = false;dialogConfirm = false" color="orange" dark>Annuler <v-icon right>remove_circle</v-icon></v-btn>
            <v-btn icons color="green" @click.stop="submitTarif" dark>Enregistrer <v-icon right>save</v-icon></v-btn>
          </p>
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>



    <!-- MODAL SHOW TYPE PROJET -->
    <v-dialog
      v-model="dialogShowTypeProjet"
      max-width="50%"
      :overlay="true"
      scrollable
      persistent
    >
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="blue">
          <v-toolbar-title
            >Détails du type de projet {{ typeProjetCourant.ref }} /
            {{ typeProjetCourant.libelle }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogShowTypeProjet = false" dark
            ><v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <el-row :gutter="20">
            <div class="grid-content bg-purple">
              <el-card class="box-card" style="background:#F9FAFC">
                <div class="text item">
                  <v-layout row wrap>
                    <v-flex md6>
                      <p><b>Référence : </b> {{ detailTypeProjet.ref }}</p>
                      <p><b>Code : </b> {{ detailTypeProjet.code }}</p>
                      <p><b>Libelle : </b> {{ detailTypeProjet.libelle }}</p>
                    
                    </v-flex>
                    <v-flex md6>
                      <p>
                        <b>Description : </b> {{ detailTypeProjet.description }}
                      </p>
                      <p>
                        <b>Date d'enregistrement :</b>
                        {{ detailTypeProjet.created }}
                      </p>
                      <p>
                        <b>Date de modification :</b>
                        {{ detailTypeProjet.modified }}
                      </p>
                    </v-flex>
                  </v-layout>
                </div>
              </el-card>

              <v-tooltip top>
                <v-btn
                  slot="activator"
                  icons
                  color="orange"
                  @click.stop="dialogShowTypeProjet = false"
                  dark
                  >Fermer <v-icon right>close</v-icon></v-btn
                >
                Fermer
              </v-tooltip>
              <v-tooltip top>
                <v-btn
                  slot="activator"
                  icons
                  color="primary"
                  @click.stop="editTypeProjet(detailTypeProjet)"
                  dark
                  >Mofifier <v-icon right>edit</v-icon></v-btn
                >
                Modifier
              </v-tooltip>
            </div>
          </el-row>
        </v-card-text>

        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- MODAL SHOW TACHE -->
    <v-dialog
      v-model="dialogShowTache"
      max-width="50%"
      :overlay="true"
      scrollable
      persistent
    >
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="blue">
          <v-toolbar-title
            >Détails de la tâche {{ tacheCourant.ref }} /
            {{ tacheCourant.libelle }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogShowTache = false" dark
            ><v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <el-row :gutter="20">
            <div class="grid-content bg-purple">
              <el-card class="box-card" style="background:#F9FAFC">
                <div class="text item">
                  <v-layout row wrap>
                    <v-flex md6>
                      <p><b>Référence : </b> {{ detailTache.ref }}</p>
                      <p><b>Libelle : </b> {{ detailTache.libelle }}</p>
                      <p><b>Type de travaux : </b> {{ detailTache.type }}</p>
                      <p><b>Ordre : </b> {{ detailTache.ordre }}</p>
                      <p>
                        <b>Prix unitaire HT : </b>
                        {{ new Intl.NumberFormat().format(detailTache.prix) }}
                      </p>
                    </v-flex>
                    <v-flex md6>
                      <p><b>Description : </b> {{ detailTache.description }}</p>
                      <p>
                        <b>Date d'enregistrement :</b> {{ detailTache.created }}
                      </p>
                      <p><b>Crée par :</b> {{ detailTache.createdUser }}</p>
                      <p>
                        <b>Date de modification :</b> {{ detailTache.modified }}
                      </p>
                      <p><b>Modifié par :</b> {{ detailTache.updateUser }}</p>
                    </v-flex>
                  </v-layout>
                </div>
              </el-card>

              <v-tooltip top>
                <v-btn
                  slot="activator"
                  icons
                  color="orange"
                  @click.stop="dialogShowTache = false"
                  dark
                  >Fermer <v-icon right>close</v-icon></v-btn
                >
                Fermer
              </v-tooltip>
              <v-tooltip top>
                <v-btn
                  slot="activator"
                  icons
                  color="primary"
                  @click.stop="editTache(detailTache)"
                  dark
                  >Mofifier <v-icon right>edit</v-icon></v-btn
                >
                Modifier
              </v-tooltip>
            </div>
          </el-row>
        </v-card-text>

        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- MODAL SHOW TACHE -->
    <v-dialog
      v-model="dialogShowTravaux"
      max-width="50%"
      :overlay="true"
      scrollable
      persistent
    >
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="blue">
          <v-toolbar-title
            >Détails des travaux {{ travauxCourant.ref }} /
            {{ travauxCourant.libelle }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogShowTravaux = false" dark
            ><v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <el-row :gutter="20">
            <div class="grid-content bg-purple">
              <el-card class="box-card" style="background:#F9FAFC">
                <div class="text item">
                  <v-layout row wrap>
                    <v-flex md6>
                      <p><b>Code : </b> {{ travauxCourant.code }}</p>
                      <p><b>Libelle : </b> {{ travauxCourant.libelle }}</p>
                      <p><b>Type de projet : </b> {{ travauxCourant.type }}</p>
                      <p><b>Ordre : </b> {{ travauxCourant.ordre }}</p>
                    </v-flex>
                    <v-flex md6>
                      <p>
                        <b>Description : </b> {{ travauxCourant.description }}
                      </p>
                      <p>
                        <b>Date d'enregistrement :</b>
                        {{ travauxCourant.created }}
                      </p>
                      <p>
                        <b>Date de modification :</b>
                        {{ travauxCourant.modified }}
                      </p>
                      <p>
                        <b>Modifié par :</b> {{ travauxCourant.updateUser }}
                      </p>
                    </v-flex>
                  </v-layout>
                </div>
              </el-card>

              <v-tooltip top>
                <v-btn
                  slot="activator"
                  icons
                  color="orange"
                  @click.stop="dialogShowTravaux = false"
                  dark
                  >Fermer <v-icon right>close</v-icon></v-btn
                >
                Fermer
              </v-tooltip>
            </div>
          </el-row>
        </v-card-text>

        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- MODAL SUPPRESSION -->
    <v-dialog
      v-model="dialogSuprTyp"
      max-width="50%"
      :overlay="true"
      scrollable
      persistent
    >
      <v-card>
        <v-card-text text-xs-center>
          <h6 align="center">
            Voulez-vous vraiment supprimer cet enregistrement ?
          </h6>
          <p align="center">
            <v-btn @click.native="dialogSuprTyp = false" color="orange" dark
              >Annuler <v-icon right>remove_circle</v-icon></v-btn
            >
            <v-btn icons color="red" @click.stop="deleteType" dark
              >Supprimer <v-icon right>delete</v-icon></v-btn
            >
          </p>
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- MODAL ADD TYPE RESSOURCE -->
    <v-dialog v-model="dialogAjoutTypeRessource" max-width="50%" :overlay="true" scrollable persistent>
        <v-card>
            <v-toolbar style="flex: 0 0 auto;" dark class="blue">
                <v-toolbar-title>
                    <span >Ajouter/Editer un type de ressource</span>
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click.native="closeType()" dark><v-icon>close</v-icon> </v-btn>
            </v-toolbar>

            <v-card-text >

                <el-form id="formTypeProj" :rules="rules" label-position="top" ref="formTypeProj" class="demo-ruleForm" >
                    <v-layout row wrap class="text-xs-center text-sm-left">
                        <v-layout row>
                            <v-flex md4 mr-1>
                                <div >
                                    <el-form-item label="Code" prop="code">
                                        <el-input name="code" placeholder="Code" v-model="typeCode" style="width:100%"></el-input>
                                    </el-form-item>
                                </div>
                            </v-flex>
                            <v-flex md4>
                                <div>
                                    <el-form-item label="Libelle" prop="libelle">
                                      <el-input name="libelle" placeholder="Libelle" v-model="typeLibelle" style="width:100%"></el-input>                                      
                                    </el-form-item>
                                </div>
                            </v-flex>
                            <v-flex md4>
                                <div>
                                    <el-form-item label="Description" prop="description">
                                        <el-input type="textarea" name="description" placeholder="Description" v-model="typeDescription" style="width:100%"></el-input>
                                    </el-form-item>
                                </div>
                            </v-flex>
                        
                        </v-layout>                      
                        
                    </v-layout>
                    <v-layout row class="text-xs-right">
                            <v-flex xs12>
                                <v-btn @click="closeType()" color="grey" dark>Annuler <v-icon right>remove_circle</v-icon></v-btn>
                                <v-btn icons color="green" @click="submitTypeRessource()"  dark>Enregistrer <v-icon right>save</v-icon></v-btn>
                            </v-flex>
                        </v-layout>
                </el-form>
            </v-card-text>
        </v-card>
    </v-dialog>

    <!-- MODAL SUPPRESSION -->
    <v-dialog
      v-model="dialogSuprLots"
      max-width="50%"
      :overlay="true"
      scrollable
      persistent
    >
      <v-card>
        <v-card-text text-xs-center>
          <h6 align="center">
            Voulez-vous vraiment supprimer cet enregistrement ?
          </h6>
          <p align="center">
            <v-btn @click.native="dialogSuprLots = false" color="orange" dark
              >Annuler <v-icon right>remove_circle</v-icon></v-btn
            >
            <v-btn icons color="red" @click.stop="deleteLots" dark
              >Supprimer <v-icon right>delete</v-icon></v-btn
            >
          </p>
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- MODAL SUPPRESSION -->
    <v-dialog
      v-model="dialogSuprTache"
      max-width="50%"
      :overlay="true"
      scrollable
      persistent
    >
      <v-card>
        <v-card-text text-xs-center>
          <h6 align="center">
            Voulez-vous vraiment supprimer cet enregistrement ?
          </h6>
          <p align="center">
            <v-btn @click.native="dialogSuprTache = false" color="orange" dark
              >Annuler <v-icon right>remove_circle</v-icon></v-btn
            >
            <v-btn icons color="red" @click.stop="deleteTaches" dark
              >Supprimer <v-icon right>delete</v-icon></v-btn
            >
          </p>
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- MODAL SUPPRESSION -->
    <v-dialog
      v-model="dialogSuprProd"
      max-width="50%"
      :overlay="true"
      scrollable
      persistent
    >
      <v-card>
        <v-card-text text-xs-center>
          <h6 align="center">
            Voulez-vous vraiment supprimer cet enregistrement ?
          </h6>
          <p align="center">
            <v-btn @click.native="dialogSuprProd = false" color="orange" dark
              >Annuler <v-icon right>remove_circle</v-icon></v-btn
            >
            <v-btn icons color="red" @click.stop="deleteTypeProd" dark
              >Supprimer <v-icon right>delete</v-icon></v-btn
            >
          </p>
        </v-card-text>
        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

 <!-- MODAL SHOW TYPE RESSOURCE -->
    <v-dialog
      v-model="dialogShowTypeRessource"
      max-width="50%"
      :overlay="true"
      scrollable
      persistent
    >
      <v-card>
        <v-toolbar style="flex: 0 0 auto;" dark class="blue">
          <v-toolbar-title
            >Détails du type de ressource
            {{ typeRessourceCourant.libelle }}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-btn icon @click.native="dialogShowTypeRessource = false" dark
            ><v-icon>close</v-icon>
          </v-btn>
        </v-toolbar>

        <v-card-text>
          <el-row :gutter="20">
            <div class="grid-content bg-purple">
              <el-card class="box-card" style="background:#F9FAFC">
                <div class="text item">
                  <v-layout row wrap>
                    <v-flex md6>                      
                      <p><b>Code : </b> {{ typeRessourceCourant.code }}</p>
                      <p><b>Libelle : </b> {{ typeRessourceCourant.libelle }}</p>
                      <p>
                        <b>Description : </b> {{ typeRessourceCourant.description }}
                      </p>
                    </v-flex>
                    <v-flex md6>
                      <p>
                        <b>Date d'enregistrement :</b>
                        {{ typeRessourceCourant.created }}
                      </p>
                      <p>
                        <b>Date de modification :</b>
                        {{ typeRessourceCourant.modified }}
                      </p>
                    </v-flex>
                  </v-layout>
                </div>
              </el-card>

              <v-tooltip top>
                <v-btn
                  slot="activator"
                  icons
                  color="orange"
                  @click.stop="dialogShowTypeRessource = false"
                  dark
                  >Fermer <v-icon right>close</v-icon></v-btn
                >
                Fermer
              </v-tooltip>
              <v-tooltip top>
                <v-btn
                  slot="activator"
                  icons
                  color="primary"
                  @click.stop="editTypeRessource(typeRessourceCourant)"
                  dark
                  >Mofifier <v-icon right>edit</v-icon></v-btn
                >
                Modifier
              </v-tooltip>
            </div>
          </el-row>
        </v-card-text>

        <div style="flex: 1 1 auto;"></div>
      </v-card>
    </v-dialog>

    <!-- MODAL MODIF LIBELLE TRAVAUX-->
    <v-dialog v-model="dialogMofifTravaux" max-width="50%" :overlay="true" scrollable persistent>
        <v-card>
            <v-toolbar style="flex: 0 0 auto;" dark class="blue">
                <v-toolbar-title>
                    <span >Modifier le libellé</span>
                </v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn icon @click.native="(dialogMofifTravaux =false)" dark><v-icon>close</v-icon> </v-btn>
            </v-toolbar>

            <v-card-text >
                <el-form id="formTypeProj" :rules="rules" label-position="top" ref="formTypeProj" class="demo-ruleForm" >
                    <v-layout row wrap class="text-xs-center text-sm-left">
                      <v-layout row>
                            <v-flex md2 mr-1>
                                <div >
                                    <el-form-item label="Ordre" prop="code">
                                        <el-input  type="number" name="ordre" placeholder="Ordre" v-model="typeCode" style="width:100%"></el-input>
                                    </el-form-item>
                                </div>
                            </v-flex>
                            <v-flex md8>
                                <div>
                                    <el-form-item label="Libelle" prop="libelle">
                                      <el-input name="libelle" placeholder="Libelle" v-model="typeLibelle" style="width:100%"></el-input>                                      
                                    </el-form-item>
                                </div>
                            </v-flex>
                            <v-flex md2>
                                <div>
                                    <el-form-item label="Code" prop="code">
                                        <el-input name="code" placeholder="Code" v-model="typeDescription" style="width:100%"></el-input>
                                    </el-form-item>
                                </div>
                            </v-flex>
                        
                        </v-layout>                                             
                    </v-layout>
                    <v-layout row class="text-xs-right">
                            <v-flex xs12>
                                <v-btn @click="dialogMofifTravaux=false" color="grey" dark>Annuler <v-icon right>remove_circle</v-icon></v-btn>
                                <v-btn icons color="green" @click="submitType()"  dark>Enregistrer <v-icon right>save</v-icon></v-btn>
                            </v-flex>
                        </v-layout>
                </el-form>
            </v-card-text>
        </v-card>
    </v-dialog>


    <formTypeProjet
      @close="closeFormTypeProjet()"
      :editedTypeProjet="typeProjetSelect"
      :show="showDialogTypeProjet"
    ></formTypeProjet>

    <formNiveauTypeTravaux
      @close="closeNiveauFormTypeTrx()"
      :idTypeNivProjet="idNivTypeProjetSelect"
      :listeLotTravaux="listeTrx"
      :show="showDialogTypeNiveauTrx"
    ></formNiveauTypeTravaux>

    <formTypeTravaux 
      @close="closeFormTypeTrx()"
      :idTypeProjet="idTypeProjetSelect"
      :etatTache ="etatTache"
      :listeLotTravaux="listeTrx"
      :show="showDialogTypeTrx"
    ></formTypeTravaux>
    <formTypeTache
      @close="closeFormTypeTache()"
      :etatTache = "etatTache"
      :idTypeTravaux="idTypeTravauxSelect"
      :listeLotTache="listeTache"
      :show="showDialogTypeTache"
    ></formTypeTache>

    <!-- pour les formulaire de duplication -->
     <dupformTypeTravaux
      @close="closeDupFormTypeTrx()"
      :listeLotTravaux="listeTrx"
      :typeProjetTab="listTypProjetTab"
      :libelleSelect="libelleSelect"
      :libelleChantier ="libelleChantier"
      :show="showDialogDupTypeTrx"
    ></dupformTypeTravaux>

      <dupformTypeTache
      @close="closeDupFormTypeTache()"
      :idTypeTravaux="idTypeTravauxSelect"
      :typeProjetTab="listTypProjetTabAll"
      :listeLotTache="listeTache"
      :libelleTacheSelect="libelleTacheSelect"
      :libelleChantier ="libelleChantier"
      :etatTache = etatTache
      :show="showDialogDupTypeTache"
    ></dupformTypeTache>

    <LoadTypeProduitExcel
      @close="closeFormTypeProduit()"
      :show="showModalLoadTypeTravaux"
      :listeTypeTravaux="lstTypeTravaux"
    ></LoadTypeProduitExcel>
  </div>
</template>

<script>
  var echarts = require('echarts/lib/echarts')
  require('echarts/lib/chart/bar')
  require('echarts/lib/chart/pictorialBar')
  require('echarts/lib/chart/funnel')
  require('echarts/lib/chart/sankey')
  require('echarts/lib/chart/scatter')
  require('echarts/lib/chart/pie')
  import Loading from "@/components/Loading";
  import formTypeProjet from "@/components/divers/formTypeProjet";
  import formNiveauTypeTravaux from "@/components/divers/formNiveauTypeTravaux";
  import formTypeTravaux from "@/components/divers/formTypeTravaux";
  import dupformTypeTravaux from "@/components/divers/formdupplication/dupformTypeTravaux";
  import dupformTypeTache from "@/components/divers/formdupplication/dupformTypeTache";

  import formTypeTache from "@/components/divers/formTypeTache";
  import LoadTypeProduitExcel from "@/components/divers/loadTypeproduit.vue";

  export default {
    components: {
      Loading,
      formTypeProjet,
      formTypeTravaux,
      formNiveauTypeTravaux,
      dupformTypeTravaux,
      dupformTypeTache,
      formTypeTache,
      LoadTypeProduitExcel
    },
    name: "app",
    data() {
      return {
        loading: false,
        domaine: JSON.parse(sessionStorage.getItem("sessionDomaine")),
        user: JSON.parse(sessionStorage.getItem("userInfo")),
        roleAcces: JSON.parse(sessionStorage.getItem("sessionAcces")),
        droitAcces: JSON.parse(sessionStorage.getItem("sessionDroit")),
        items: [
          { path: "/", text: "Accueil", disabled: false },
          { path: "/keywords", text: "Gestion des mots clés", disabled: true }
        ],
        rules:{
              code: [
                  {required:true, message: "Veuillez  saisir un code",trigger: 'blur' }
              ],
              libelle: [
                  {required:true, message: "Veuillez  saisir un libelle",trigger: 'blur' }
              ],
              description: [
                  {required:false, message: "Veuillez  saisir une description",trigger: 'blur' }
              ],
          },
          formTypeProj:{
              id:"",
              libelle: "",
              description:""
          },
        columns: [
          {
            prop: "libelle",
            label: "Libellé lot"
          },
          {
            prop: "ordre",
            label: "Ordre d'éxécution"
          },
          {
            prop: "code",
            label: "Code"
          },
          {
            prop: "description",
            label: "Description"
          }
        ],
        listeRapportTrx: {
          type: Array
        },

        taches: [
          {
            prop: "libelle",
            label: "Libellé tâche"
          },
          {
            prop: "ordre",
            label: "Ordre d'éxécution"
          },
          {
            prop: "unite",
            label: "Unité"
          },
          {
            prop: "prix",
            label: "Prix unitaire HT (FCFA)"
          },
          {
            prop: "description",
            label: "Description"
          }
        ],
        tachesTypeProduit: [
          {
            prop: "codeGestion",
            label: "Code article"
          },
          {
            prop: "codeAnalytique",
            label: "Code analytique"
          },
          {
            prop: "referenceProduit",
            label: "Référence"
          },
          {
            prop: "libelleProduit",
            label: "Libellé"
          },
          {
            prop: "valeurProduit",
            label: "Prix de (vente ou d'utilisation)(Fcfa)"
          },
          {
            prop: "libelleUnite",
            label: "Unité"
          },
          {
            prop: "descProduit",
            label: "Description"
          }
        ],

        valid: true,

        dialogAjoutTypeRessource: false,
        dialogAjoutTache: false,
        dialogAjoutTravaux: false,
        dialogDupliquerTravaux: false,
        dialogAjoutProduit: false,
        dialogAjoutCategory: false,
        dialogSuprCategorie: false,
        dialogSuprKeyword: false,
        dialogEdit: false,
        dialogMofifTravaux: false,
        dialogEditCategorie: false,
        dialogShowTypeProjet: false,
        dialogShowCategorie: false,
        dialogShowTache: false,
        dialogEditProduit: false,
        dialogShowProduit: false,
        
        dialogSuprLexique: false,
        dialogShowTravaux: false,
        idProduit: "",
        idCategorie: "",
        idLexique: "",
        libelleProduit: "",
        libelleUnite: "Pcs",
        descProduit: "",
        typeProduit: "",
        codeType: '',
        valeurProduit: 0,
        ordre: 1,
        dialogTarif: false,
        dialogConfirm: false,
        referenceProduit: "",
        libelleCategorie: "",
        descCategorie: "",
        currentCategorie: {},
        currentProduit: {},
        categorie: "",
        itemsTypeProjet: [],
        itemsTravaux: [],
        itemsProduit: [],
        itemsTypeProduit: [],
        itemsTaches: [],
        categorieEdit: "",
        listCategorie: [],
        tableLots: [],
        tableTaches: [],
        tableTypeProduit: [],
        listeType: [],
        listeChantier: [],
        tableLotsNEW: [],
        tab: 0,
        tab1: 0,
        listProduit: [],
        IdProduiSelect: "",
        selectSearchTypeProjet: "",
        selectSearchTypeRessource: "",
        selectSearchTravaux: "",
        selectSearchProduit: "",
        selectSearchTypeProduit: "",
        selectSearchTache: "",
        listLexique: [],
        selectTypeEntre: "",
        dialogSupTarif:'',
        listTypeProjet: [],
        listTypeRessource:[],

        typeProjetCourant: [],
        typeRessourceCourant: [],
        dialogShowTypeRessource:false,
        detailTypeProjet: [],
        formTache: {
          id: "",
          libelle: "",
          ordre: 1,
          unite: "",
          prix: 0,
          description: ""
        },
        formTypeProduit: {
          id: "",
          referenceProduit: "",
          codeAnalytique:"",
          libelleProduit: "",
          valeurProduit: "",
          libelleUnite: 0,
          descProduit: ""
        },
        listTache: [],
        tacheCourant: [],
        detailTache: [],
        dialogSuprTyp: false,
        dialogSuprLots: false,
        dialogSuprTache: false,
        dialogSuprProd: false,
        //FILTRE
        listeProjet: [],
        listeChantier: [],
        BesoinsList: [],
        listeProduitAffich: [],
        projetS: "",
        IdTypeSelct: "",
        chantierS: "",
        produitCourant: [],
        listTravaux: [],
        typeProjet: "",
        travaux: "",
        listAllTravaux: [],
        formTravaux: {
          id: "",
          libelle: "",
          ordre: "",
          code: "",
          description: ""
        },
        travauxCourant: [],

        listeProduitFourn: [],
        listeCommandeFourn: [],
        listeStatistik:[],
        listeStokProd: [],
        listeStokEnlev: [],
        detailProjet: [],
        //formulaire type projet
        showDialogTypeProjet: false,
        showDialogTypeTrx: false,
        typeProjetSelect: null,
        showDialogTypeRessource: null,

        showDialogTypeNiveauTrx: false,
        //formulaire dupliquer type lot/travaux
        showDialogDupTypeProjet: false,
        showDialogDupTypeTrx: false,
        typeDupProjetSelect: null,
        listTypProjetTab: [],
        libelleSelect: "",
        selecAnne:'',
        totalCommande: 0,
        totalQteCommande: 0,

        //formulaire dupliquer taches des travaux
        listeTache: [],
        listeTacheTravaux: [],
        listTypProjetTabAll: [],
        idTypeTravauxSelect: null,
        etatTache:'',
        showDialogDupTypeTache: false,
        libelleTacheSelect: "",
        libelleChantier:"",
        codeGestion:'',
        listcodeGestion: [],
        typeDescription:'',
        typeLibelle:'',
        typeCode:'',
        editedTypeRessource:[],

        //formulaire type travaux
        listeTrx: [],
        listeProjetTravaux: [],
        idTypeProjetSelect: null,

        idNivTypeProjetSelect: null,

        //formulaire type tache
        listeTache: [],
        listeTacheTravaux: [],
        showDialogTypeTache: false,
        prixAchat:'',
        selectProduit:'',
        selectIdProduit:'',
        valeurUniteMateriel:'',
        tarifCourant: [],

        showModalLoadTypeTravaux: false,

        //Importer fichier excel
        fileExcel: [],
        lstTypeTravaux: []
      };
    },
    computed: {},
    watch: {
      show: function(newValue, oldvalue) {
        if (newValue == true) {
          //this.oldListTravaux = this.listeTrx;
        }
      }
    },
    methods: {
      statPrixFourn(dataFactHistoFour) {
            var posList = [
                'left', 'right', 'top', 'bottom',
                'inside',
                'insideTop', 'insideLeft', 'insideRight', 'insideBottom',
                'insideTopLeft', 'insideTopRight', 'insideBottomLeft', 'insideBottomRight'
          ];


          app.configParameters = {
              rotate: {
                  min: -90,
                  max: 90
              },
              align: {
                  options: {
                      left: 'left',
                      center: 'center',
                      right: 'right'
                  }
              },
              verticalAlign: {
                  options: {
                      top: 'top',
                      middle: 'middle',
                      bottom: 'bottom'
                  }
              },
              position: {
                  options: echarts.util.reduce(posList, function (map, pos) {
                      map[pos] = pos;
                      return map;
                  }, {})
              },
              distance: {
                  min: 0,
                  max: 100
              }
          };

          app.config = {
              rotate: 90,
              align: 'left',
              verticalAlign: 'middle',
              position: 'insideBottom',
              distance: 15,
              onChange: function () {
                  let  labelOption = {
                      normal: {
                          rotate: app.config.rotate,
                          align: app.config.align,
                          verticalAlign: app.config.verticalAlign,
                          position: app.config.position,
                          distance: app.config.distance
                      }
                  };
                  myChart.setOption({
                      series: [{
                          label: labelOption
                      }, {
                          label: labelOption
                      }, {
                          label: labelOption
                      }]
                  });
              }
          };


          let labelOption = {
              show: true,
              position: app.config.position,
              distance: app.config.distance,
              align: app.config.align,
              verticalAlign: app.config.verticalAlign,
              rotate: app.config.rotate,
              formatter: '{c}  {name|{a}}',
              fontSize: 16,
              rich: {
                  name: {
                      textBorderColor: '#fff'
                  }
              }
          };


          let option = {
              color: ['#388E3C', '#F57C00', '#455A64', '#C62828'],
              tooltip: {
                  trigger: 'axis',
                  axisPointer: {
                      type: 'shadow'
                  }
              },
              legend: {},
              toolbox: {
                  show: true,
                  orient: 'vertical',
                  left: 'right',
                  top: 'center',
                  feature: {
                      mark: {show: true},
                      dataView: {show: true, readOnly: false},
                      magicType: {show: true, type: ['line', 'bar', 'stack', 'tiled']},
                      restore: {show: true},
                      saveAsImage: {show: true}
                  }
              },
              xAxis: [
                  {
                      type: 'category',
                      axisTick: {show: false},
                      data: []
                  }
              ],
              yAxis: [
                  {
                      type: 'value'
                  }
              ],
              series: [
                  {
                      name: 'Prix actuel',
                      type: 'bar',
                      barGap: 0,
                      label: labelOption,
                      data: []
                  },
                  {
                      name: 'Ancien prix',
                      type: 'bar',
                      label: labelOption,
                      data: []
                  }
              ]
          }; //option

          for(let datahis in dataFactHistoFour){
              option.xAxis[0].data.push(datahis);
              let series = dataFactHistoFour[datahis]
              option.series[0].data.push(series["prix actuel"]);
              option.series[1].data.push(series["ancien prix"]);
          }

          let chartFactureAnFour = echarts.init(document.getElementById('chartFactureAnFour'))
          chartFactureAnFour.setOption(option)
      },
      statComRessour(dataFactHistoFour) {
            var posList = [
                'left', 'right', 'top', 'bottom',
                'inside',
                'insideTop', 'insideLeft', 'insideRight', 'insideBottom',
                'insideTopLeft', 'insideTopRight', 'insideBottomLeft', 'insideBottomRight'
          ];


          app.configParameters = {
              rotate: {
                  min: -90,
                  max: 90
              },
              align: {
                  options: {
                      left: 'left',
                      center: 'center',
                      right: 'right'
                  }
              },
              verticalAlign: {
                  options: {
                      top: 'top',
                      middle: 'middle',
                      bottom: 'bottom'
                  }
              },
              position: {
                  options: echarts.util.reduce(posList, function (map, pos) {
                      map[pos] = pos;
                      return map;
                  }, {})
              },
              distance: {
                  min: 0,
                  max: 100
              }
          };

          app.config = {
              rotate: 90,
              align: 'left',
              verticalAlign: 'middle',
              position: 'insideBottom',
              distance: 15,
              onChange: function () {
                  let  labelOption = {
                      normal: {
                          rotate: app.config.rotate,
                          align: app.config.align,
                          verticalAlign: app.config.verticalAlign,
                          position: app.config.position,
                          distance: app.config.distance
                      }
                  };
                  myChart.setOption({
                      series: [{
                          label: labelOption
                      }, {
                          label: labelOption
                      }, {
                          label: labelOption
                      }]
                  });
              }
          };


          let labelOption = {
              show: true,
              position: app.config.position,
              distance: app.config.distance,
              align: app.config.align,
              verticalAlign: app.config.verticalAlign,
              rotate: app.config.rotate,
              formatter: '{c}  {name|{a}}',
              fontSize: 16,
              rich: {
                  name: {
                      textBorderColor: '#fff'
                  }
              }
          };


          let option = {
              color: ['#388E3C', '#F57C00', '#455A64', '#C62828'],
              tooltip: {
                  trigger: 'axis',
                  axisPointer: {
                      type: 'shadow'
                  }
              },
              legend: {},
              toolbox: {
                  show: true,
                  orient: 'vertical',
                  left: 'right',
                  top: 'center',
                  feature: {
                      mark: {show: true},
                      dataView: {show: true, readOnly: false},
                      magicType: {show: true, type: ['line', 'bar', 'stack', 'tiled']},
                      restore: {show: true},
                      saveAsImage: {show: true}
                  }
              },
              xAxis: [
                  {
                      type: 'category',
                      axisTick: {show: false},
                      data: []
                  }
              ],
              yAxis: [
                  {
                      type: 'value'
                  }
              ],
              series: [
                  {
                      name: 'Qte commandée',
                      type: 'bar',
                      barGap: 0,
                      label: labelOption,
                      data: []
                  },
                  {
                      name: 'Prix',
                      type: 'bar',
                      label: labelOption,
                      data: []
                  },
                  {
                      name: 'Total TTC',
                      type: 'bar',
                      label: labelOption,
                      data: []
                  }
              ]
          }; //option

          for(let datahis in dataFactHistoFour){
              option.xAxis[0].data.push(datahis);
              let series = dataFactHistoFour[datahis]
              option.series[0].data.push(series["Qte commandée"]);
              option.series[1].data.push(series["Prix"]);
              option.series[2].data.push(series["Total TTC"]);
          }

          let chartCommFour = echarts.init(document.getElementById('chartCommFour'))
          chartCommFour.setOption(option)
      },
      statEntrepot(dataFactHistoFour) {
            var posList = [
                'left', 'right', 'top', 'bottom',
                'inside',
                'insideTop', 'insideLeft', 'insideRight', 'insideBottom',
                'insideTopLeft', 'insideTopRight', 'insideBottomLeft', 'insideBottomRight'
          ];


          app.configParameters = {
              rotate: {
                  min: -90,
                  max: 90
              },
              align: {
                  options: {
                      left: 'left',
                      center: 'center',
                      right: 'right'
                  }
              },
              verticalAlign: {
                  options: {
                      top: 'top',
                      middle: 'middle',
                      bottom: 'bottom'
                  }
              },
              position: {
                  options: echarts.util.reduce(posList, function (map, pos) {
                      map[pos] = pos;
                      return map;
                  }, {})
              },
              distance: {
                  min: 0,
                  max: 100
              }
          };

          app.config = {
              rotate: 90,
              align: 'left',
              verticalAlign: 'middle',
              position: 'insideBottom',
              distance: 15,
              onChange: function () {
                  let  labelOption = {
                      normal: {
                          rotate: app.config.rotate,
                          align: app.config.align,
                          verticalAlign: app.config.verticalAlign,
                          position: app.config.position,
                          distance: app.config.distance
                      }
                  };
                  myChart.setOption({
                      series: [{
                          label: labelOption
                      }, {
                          label: labelOption
                      }, {
                          label: labelOption
                      }, {
                          label: labelOption
                      }]
                  });
              }
          };


          let labelOption = {
              show: true,
              position: app.config.position,
              distance: app.config.distance,
              align: app.config.align,
              verticalAlign: app.config.verticalAlign,
              rotate: app.config.rotate,
              formatter: '{c}  {name|{a}}',
              fontSize: 16,
              rich: {
                  name: {
                      textBorderColor: '#fff'
                  }
              }
          };


          let option = {
              color: ['#388E3C', '#F57C00', '#455A64', '#C62828'],
              tooltip: {
                  trigger: 'axis',
                  axisPointer: {
                      type: 'shadow'
                  }
              },
              legend: {},
              toolbox: {
                  show: true,
                  orient: 'vertical',
                  left: 'right',
                  top: 'center',
                  feature: {
                      mark: {show: true},
                      dataView: {show: true, readOnly: false},
                      magicType: {show: true, type: ['line', 'bar', 'stack', 'tiled']},
                      restore: {show: true},
                      saveAsImage: {show: true}
                  }
              },
              xAxis: [
                  {
                      type: 'category',
                      axisTick: {show: false},
                      data: []
                  }
              ],
              yAxis: [
                  {
                      type: 'value'
                  }
              ],
              series: [

                  {
                      name: 'appro',
                      type: 'bar',
                      barGap: 0,
                      label: labelOption,
                      data: []
                  },
                  {
                      name: 'stock',
                      type: 'bar',
                      label: labelOption,
                      data: []
                  },
                  {
                      name: 'sortie',
                      type: 'bar',
                      label: labelOption,
                      data: []
                  },
                  {
                      name: 'retour',
                      type: 'bar',
                      label: labelOption,
                      data: []
                  }
              ]
          }; //option

          for(let datahis in dataFactHistoFour){
              option.xAxis[0].data.push(datahis);
              let series = dataFactHistoFour[datahis]
              option.series[0].data.push(series["appro"]);
              option.series[1].data.push(series["stock"]);
              option.series[2].data.push(series["sortie"]);
              option.series[3].data.push(series["retour"]);
          }

          let chartStockProd = echarts.init(document.getElementById('chartStockProd'))
          chartStockProd.setOption(option)
      },
      handleTabClick1(onglet) {
        switch (onglet) {
          case "0": //TYPE PROJET
            this.loadTypeProjet();
            break;
          case "1": //TYPE LOT DE TRAVAUX
            this.loadTravauxParType();
            break;
          case "2": //TYPE LOT DE TACHE
            this.loadTacheParTypeTrx();
            break;
          case "3": //TYPE DE RESSOURCE
            this.loadTypeRessource();
            break;
          case "4": //TYPE DE PORDUIT
            this.loadProduit();
            break;
        }
      },
      TabClick(onglet) {
        switch (onglet) {
          case "0": //PRIX FOURNISSEUR
            this.loadProdFourn();
            break;
          case "1": //LISTE COMMANDE
            this.loadCommandFourn();
            break;
          case "2": //LISTE STOCK et ENLEVEMENT
            this.loadStockFourn();
            break;
          case "3": //LISTE STATISTIQUE
            var ladate= new Date()
            this.loadStatistique(ladate);
          break;


        }
      },
      loadProdFourn() {
        let url = "";
        this.loading = true
        url = this.domaine + "product/fournisseur/product-list/"+this.currentProduit.id;
        this.$http.get(url).then(response => {
          if (response.body) {
            this.loading = false
            this.listeProduitFourn = response.body.produit;
            this.statPrixFourn(response.body.dataStat)
          }
        },error=> {
          this.loading = false;
        });
      },
      loadCommandFourn() {
        let url = "";
        this.loading = true
        url = this.domaine+"fournisseur/"+this.currentProduit.id +"/commande/liste";
        this.$http.get(url).then(response => {
          if (response.body) {
            this.loading = false
            this.listeCommandeFourn = response.body.commande;
            this.statComRessour(response.body.dataStat)
          }
        },error=> {
          this.loading = false;
        });
      },
      loadStatistique(anne) {
        let url = "";
        this.loading = true
        url = this.domaine +'product/'+this.currentProduit.id +"/statistique/produit/"+anne.getFullYear();
        this.$http.get(url).then(response => {
          if (response.body) {
            this.loading = false
            this.totalCommande = response.body.totalCommande;
            this.totalQteCommande = response.body.totalQteCommande;
            this.listeStatistik = response.body.dataProduit;
            this.statDepenseAn(this.listeStatistik)
          }
        },error=> {
          this.loading = false;
        });
      },
      loadStockFourn() {
        let url = "";
        this.loading = true
        url = this.domaine +'entrepot/'+this.currentProduit.id +"/stock/liste/produit";
        this.$http.get(url).then(response => {
          if (response.body) {
            this.loading = false
            this.listeStokProd = response.body.stock;
            this.listeStokEnlev = response.body.enlev;
            this.statEntrepot(response.body.dataStat)
          }
        },error=> {
          this.loading = false;
        });
      },
      closeFormTypeProjet() {
        this.showDialogTypeProjet = false;
        this.loadTypeProjet();
      },
      closeFormTypeTrx() {
        this.showDialogTypeTrx = false;
        this.loadTravauxParType();
      },
      closeNiveauFormTypeTrx() {
      this.showDialogTypeNiveauTrx = false
        this.loadTacheParTypeTrx();
      },    
      closeDupFormTypeTrx() {
        this.showDialogDupTypeTrx = false;
        this.loadTravauxParType();
      },
      closeFormTypeTache() {
        this.showDialogTypeTache = false;
        this.loadTacheParTypeTrx();
      },
      closeDupFormTypeTache() {
        this.showDialogDupTypeTache = false;
        this.loadTacheParTypeTrx();
      },
      closeFormTypeProduit() {
        this.showModalLoadTypeTravaux = false;
        this.loadProduit();
      },
      tableRowClassName({ row, rowIndex }) {
        if (rowIndex === 1) {
          return "warning-row";
        } else if (rowIndex === 3) {
          return "success-row";
        }
        return "";
      },
      loadPage() {
        const loading = this.$loading({
          lock: true,
          text: "Veuillez patientez ...",
          spinner: "el-icon-loading",
          background: "rgba(0, 0, 0, 0.7)"
        });
        setTimeout(() => {
          loading.close();
        }, 1000);
      },
      filtrerTypeProjet() {
        let idType = this.selectSearchTypeProjet;
        let tableau = this.listTypeProjet;

        this.listTypeProjet = tableau.filter(function(item) {
          return item.id == idType;
        });
        if (idType == null || idType == "undefined" || idType == "") {
          this.loadTypeProjet();
          let tableau = this.listTypeProjet;
          this.listTypeProjet = tableau;
          return;
        }
      },
       filtrerTypeRessource() {
        let idType = this.selectSearchTypeRessource;
        let tableau = this.listTypeRessource;

        this.listTypeRessource = tableau.filter(function(item) {
          return item.id == idType;
        });
        if (idType == null || idType == "undefined" || idType == "") {
          this.loadTypeRessource();
          let tableau = this.listTypeRessource;
          this.listTypeRessource = tableau;
          return;
        }
      },
      filtrerTravaux() {
        let idType = this.selectSearchTravaux;
        let tableau = this.listAllTravaux;

        this.listAllTravaux = tableau.filter(function(item) {
          return item.id == idType;
        });
        if (idType == null || idType == "undefined" || idType == "") {
          this.loadAllTravaux();
          let tableau = this.listAllTravaux;
          this.listAllTravaux = tableau;
          return;
        }
      },
      filtrerTache() {
        let idType = this.selectSearchTache;
        let tableau = this.listTache;
        this.listTache = tableau.filter(function(item) {
          return item.idType == idType;
        });
      },
      SelectionTypePrdotuit(item) {
       let data = this.listTypeRessource.filter(function(row){
          if(row.libelle == item) { 
            return row.code
          }
        })
        this.codeType = data[0].code

      },
      filtrerTacheType() {
        let idType = this.selectSearchTache;
        let tableau = this.listTache;

        this.listTache = tableau.filter(function(item) {
          return item.id == idType;
        });
        if (idType == null || idType == "undefined" || idType == "") {
          this.loadTache();
          let tableau = this.listTache;
          this.listTache = tableau;
          return;
        }
      },
      filtrerTypeProduit() {
        let idType = this.selectSearchTypeProduit;
        let tableau = this.listProduit;

        this.listProduit = tableau.filter(function(item) {
          return item.type == idType;
        });
        if (idType == null || idType == "undefined" || idType == "") {
          this.loadProduit();
          let tableau = this.listProduit;
          this.listProduit = tableau;
          return;
        }
      },
      filtrerProduit() {
        let idType = this.selectSearchProduit;
        let tableau = this.listProduit;

        this.listProduit = tableau.filter(function(item) {
          return item.id == idType;
        });
        if (idType == null || idType == "undefined" || idType == "") {
          this.loadProduit();
          let tableau = this.listProduit;
          this.listProduit = tableau;
          return;
        }
      },
      filtrerChantier() {
        let idChant = this.chantierS;
        this.listTache = this.listeRapportTrx.filter(function(item) {
          return item.idType == idChant;
        });
      },
      clearSelect() {
        this.selectSearchTypeProjet = "";
        this.chantierS = "";
        this.projetS = "";
      },
      loadProduit() {
        let url = "";
        this.loading = true;
        url = this.domaine + "product/product-list";
        this.$http.get(url).then(response => {
          if (response.body) {
          this.loading = false;
            this.listProduit = response.body;
            this.listeProduitAffich = response.body;
            this.itemsProduit = response.body;
          }
        });
      },
      loadTypeProduit() {
        this.loading = true;
        if (this.IdTypeSelct != 0) {
          let url =
            this.domaine + "product/productSelect/type/" + this.IdTypeSelct;
          this.$http.get(url).then(
            response => {
              this.loading = false;
              this.listeProduitAffich = response.body.produits;
            },
            errRep => {
              this.loading = false;
              this.$message.error(
                "Une erreur est survenue lors du chargement de la liste du chntier"
              );
            }
          );
        } else {
          this.loadProduit();
          this.loading = false;
        }
      },
      loadLexique() {
        let url = this.domaine + "keyword/lexique-list/" + this.currentProduit.id;
        this.$http.get(url).then(response => {
          if (response.body) {
            this.listLexique = response.body;
          }
        });
      },
      loadTypeProjet() {
        // this.getLoadSearch()
        let url = "";
        if (this.droitAcces.index_type_tache) {
          url = this.domaine + "projet/index/type/projet";
        } else {
          url = this.domaine + "projet/" + this.user.id + "/index/type/projet";
        }
        this.$http.get(url).then(response => {
          if (response.body) {
            this.listTypeProjet = response.body.type;
            this.listeType = response.body.type;
            this.itemsTypeProjet = response.body.type;
          }
        });
      },
      loadTypePrjt() {
        let url = "";
          url = this.domaine + "projet/list/type/projet/vide";
        this.$http.get(url).then(response => {
          if (response.body) {
            this.listTypProjetTab = response.body.type;

            //contient tous les types travaux qui ont des lot
            this.listTypProjetTabAll = response.body.typeAll;
          }
        });
      },
      editTarif (ligne) {
        this.dialogTarif = true
        this.tarifCourant = ligne
        this.selectProduit = ligne.libelle
        this.selectIdProduit = ligne.idprod
        this.prixAchat = ligne.prixAchat
        this.valeurUniteMateriel = ligne.unite
      },
      loadTravaux() {
        this.loading = true;
        this.travaux = "";
        this.listTravaux = [];
        if (this.typeProjet !== "") {
          let url =
            this.domaine +
            "product/" +
            this.typeProjet +
            "/type/projet/index/travaux";
          this.$http.get(url).then(response => {
            if (response.body) {
              this.listTravaux = response.body.travaux;
              this.loading = false;
            }
          });
        } else {
          this.$message.error("Veuillez sélectionner un projet");
          this.loading = false;
        }
      },
      loadTravauxBytype() {
        if (
          this.projetS == null ||
          this.projetS == "undefined" ||
          this.projetS == ""
        ) {
          this.listTache = this.listeRapportTrx;
          return;
        }
        this.loading = true;
        let url = "";
        url = this.domaine + "product/projet/travaux/" + this.projetS + "/index";

        this.$http.get(url).then(response => {
          if (response.body) {
            this.listeChantier = response.body.travaux;
            this.loading = false;
          }
        });
      },
      loadAllTravaux() {
        this.loading = true;
        let url = "";
        if (this.droitAcces.all_travaux_projet) {
          url = this.domaine + "product/projet/travaux/index";
        } else {
          url = this.domaine + "product/projet/" + this.user.id + "/travaux/index";
        }
        this.$http.get(url).then(response => {
          if (response.body) {
            this.listAllTravaux = response.body.travaux;
            this.itemsTravaux = response.body.travaux;
            this.loading = false;
          }
        });
      },
      loadTravauxParType() {
        this.loading = true;
        setTimeout(() => {
          this.listeProjetTravaux.splice(0);
          let url = this.domaine + "projet/liste/typeTravaux";
          this.$http.get(url).then(
            response => {
              this.listeProjetTravaux = response.body.listeProjetTravaux;
              this.loading = false;
            },
            error => {
              this.loading = false;
              this.$message.error("Erreur lors du chargement des travaux ");
            }
          );
        }, 2000);
      },
      loadTacheParTypeTrx() {
        this.loading = true;
        setTimeout(() => {
          let url = this.domaine + "projet/liste/typeTache";
          this.$http.get(url).then(
            response => {
              this.listeTacheTravaux = response.body.listeProjetTravauxTache;
              this.loading = false;
            },
            error => {
              this.loading = false;
              this.$message.error("Erreur lors du chargement des taches ");
            }
          );
        }, 2000);
      },
      deleteTache(position, rows) {
        let tableau = [];
        rows.splice(position, 1);
        this.tableLotsNEW = this.tableTaches;
        this.tableTaches = [];

        for (let index = 0; index < this.tableLotsNEW.length; index++) {
          let tab = [];
          this.tab = {
            id: index + 1,
            libelle: this.tableLotsNEW[index]["libelle"],
            ordre: index + 1,
            unite: this.tableLotsNEW[index]["unite"],
            prix: this.tableLotsNEW[index]["prix"],
            description: this.tableLotsNEW[index]["description"]
          };
          this.tableTaches.push(this.tab);
        }

        var input = document.getElementById("ordreTache");
        this.formTache = {
          ordre: this.tableTaches.length == 0 ? 1 : this.tableTaches.length + 1
        };
      },
      deleteTypeProduit(position, rows) {
        rows.splice(position, 1);
      },
      deleteTarif(ligne) {      
        this.dialogSupTarif = true
        this.tarifCourant= ligne
        this.selectProduit = ligne.libelle
      },
      deleteTarification() {
         this.loading = true
          let url = "";
          let idTarif = this.tarifCourant['id']
          url =this.domaine + "fournisseur/delete/"+idTarif+"/tarif";
          this.$http.get(url).then(response => {
            if(response.body.code == 2) {
            this.dialogSupTarif = false
            this.loading = false
              this.$notify({
                  title: 'SUPPRESSION REUSSI',
                  message: 'Tarification supprimé avec succès.',
                  type: 'success',
                  position: 'top-center'
              })
              this.loadProdFourn()
            }else{
            this.loading = false
                this.$message.error('Impossible de supprimer la tarification de ce produit car il est déja utilisé dans une commande')
            }
          },
          error => {
            // this.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur')
            this.$message.error('Impossible de supprimer la tarification de ce produit, il est lié à une commande.')
            this.loading = false
          })
      },
      deleteRow(position, rows) {
        let tableau = [];
        rows.splice(position, 1);
        this.tableLotsNEW = this.tableLots;
        this.tableLots = [];

        for (let index = 0; index < this.tableLotsNEW.length; index++) {
          let tab = [];
          this.tab = {
            id: index + 1,
            libelle: this.tableLotsNEW[index]["libelle"],
            code: this.tableLotsNEW[index]["code"],
            ordre: index + 1,
            description: this.tableLotsNEW[index]["description"]
          };
          this.tableLots.push(this.tab);
        }
        var input = document.getElementById("ordre");
        this.formTravaux = {
          ordre: this.tableLots.length == 0 ? 1 : this.tableLots.length + 1
        };
      },
      loadTache() {
        let url = "";
        if (this.droitAcces.index_tache_type) {
          url = this.domaine + "projet/index/tache/type";
        } else {
          url = this.domaine + "projet/index/" + this.user.id + "/tache/type";
        }
        this.$http.get(url).then(response => {
          if (response.body) {
            this.listTache = response.body.tache;
            this.listeRapportTrx = response.body.tache;
            this.itemsTaches = response.body.tache;
          }
        });
      },
      showTypeProjet(item) {
        this.dialogShowTypeProjet = true;
        this.typeProjetCourant = item;
        let url =
          this.domaine +
          "projet/" +
          this.typeProjetCourant.id +
          "/show/type/projet";
        this.loading = true;
        this.$http.get(url).then(response => {
          this.loading = false;
          if (response.body) {
            this.detailTypeProjet = response.body.type;
          }
        });
      },
      showTypeRessource(item) {
        this.dialogShowTypeRessource = true;
        this.typeRessourceCourant = item;     
      },
      showTache(item) {
        this.dialogShowTache = true;
        this.tacheCourant = item;
        let url = this.domaine + "projet/" + this.tacheCourant.id + "/show/tache";
        this.loading = true;
        this.$http.get(url).then(response => {
          this.loading = false;
          if (response.body) {
            this.detailTache = response.body.tache;
          }
        });
      },
      showProduit(item) {
        this.dialogShowProduit = true;
        this.currentProduit = item;
        this.loadProdFourn();
      },
      showCategorie(item) {
        this.dialogShowCategorie = true;
        this.currentCategorie = item;
      },
      newTypeProjet() {
        this.showDialogTypeProjet = true;
      },
      newTypeRessource() {
        this.typeLibelle =''
        this.typeCode = ''
        this.typeDescription =''  
        this.editedTypeRessource =[]      
        this.dialogAjoutTypeRessource = true;
      },
      newTache(item, etat = null) {

        this.showDialogTypeTache = true;
        this.etatTache = etat
        this.idTypeTravauxSelect = parseInt(item.idTypeTrx);
        this.listeTache.splice(0);
        this.listeTache = item.listeTypeTache.slice();
      },
      newTravaux(item) {  
        this.showDialogTypeTrx = true;
        this.listeTrx.splice(0);         
        this.listeTrx = item.listeTypeTravaux.slice();
        this.listeTrx = item.listeTypeTravaux;
        this.idTypeProjetSelect = parseInt(item.idTypeProjet);
        conosole.log('rhrhrhr', this.listeTrx )
        conosole.log('idTypeProjetSelect', this.idTypeProjetSelect )
      },
      newNiveau(item) {
        this.idNivTypeProjetSelect = item.idTypeTrx;
        this.listeTrx.splice(0);      
        this.listeTrx = item.sous
        this.showDialogTypeNiveauTrx = true;
      },
      duplicateTravaux(item) {
        this.libelleSelect = item.libelle
        //recherche de tous les types projet qui non pas de lot
        this.loadTypePrjt()
        this.showDialogDupTypeTrx = true;
        this.listeTrx.splice(0);
        this.listeTrx = item.listeTypeTravaux.slice();
        this.idTypeProjetSelect = parseInt(item.idTypeProjet);
      },
      duplicateTaches(item,itmChantier) {
        if(item.nbSous != 0) {
          this.etatTache = 'niveau'
        }

        this.libelleTacheSelect = item.libelle
        this.libelleChantier = itmChantier.libelle
        this.loadTypePrjt()
        this.showDialogDupTypeTache = true;
        this.listeTache.splice(0);
        this.listeTache = item.listeTypeTache.slice();
        this.idTypeTravauxSelect = parseInt(item.idTypeTrx);
      },
      loadCodeGestion() {
      this.listcodeGestion = [];
      let url =this.domaine + "product/gestionCode";
        this.$http.get(url).then(response => {
          if (response.body) {
            this.listcodeGestion = response.body.code;
            this.loading = false;
          }
        });
      },
      loadTypeRessource() {
      this.listcodeGestion = [];
      let url =this.domaine + "product/typeRessource";
        this.$http.get(url).then(response => {
          if (response.body) {
            this.listTypeRessource = response.body.types;
            this.loading = false;
          }
        });
      },
      submitType() {
        this.loading = true              
        let data = new FormData()        
        data.append('libelle',this.typeLibelle)
        data.append('ordre',this.typeCode)  
        data.append('code',this.typeDescription)
        data.append('idUser', this.user.id)
        let url = this.domaine + 'projet/' + this.editedType.idTypeTrx + '/edit/type/travaux'
        this.$http.post(url, data).then(response => {
            this.loading = false;
            this.dialogMofifTravaux = false
            if (response.body.code == 3) {
                this.$message.error(response.body.message)
                return;
            }
            this.$notify({
              title: 'MODIFICATION REUSSI',
              message: 'Type de travaux enregistré avec succès.',
              type: 'success',
              position: 'top-center'
          });
          this.loadTravauxParType()
        })
      },
      submitTarif () {
          this.loading = true
          var form = document.getElementById("formTarif");
          var data = new FormData(form);
          let url = "";
          let idTarif = this.tarifCourant['id']
          url =this.domaine + "fournisseur/new/" +idTarif+ "/tarif";
          data.append('produit', this.selectProduit)
          data.append('selectIdProduit', this.selectIdProduit)
          data.append('idUser', this.user.id)
          this.tableTarification = []
          data.append("tarif", JSON.stringify(this.tableTarification));
          this.$http.post(url, data).then(response => {
              if (response.body) {
                  let verif = response.body
                  if (verif.code === 1) {
                      this.$notify({
                          title: 'ENREGISTREMENT REUSSI',
                          message: 'Tarification enregistré avec succès.',
                          type: 'success',
                          position: 'top-center'
                      })
                  }
                  this.loadProdFourn()
                  this.dialogTarif = false
                  this.dialogConfirm = false
                  this.loading = false
              } else {
                  this.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur')
                  this.loading = false
                  this.dialogAppro = false
              }
          },
          response => {
              this.$message.error('Une erreur est survenue. Veuillez contacter votre administrateur')
              this.loading = false
      })
      },
      closeType() {
        this.dialogAjoutTypeRessource = false
      },
      submitTypeRessource() {                   
        this.loading = true              
        let data = new FormData()
        data.append('libelle',this.typeLibelle)
        data.append('code',this.typeCode)
        
        data.append('description',this.typeDescription)
        data.append('idUser', this.user.id)
        let url = "";
        if (this.editedTypeRessource.id) {
            url = this.domaine + 'product/' + this.editedTypeRessource.id + '/edit/type/ressource'
        } else {
            url = this.domaine + 'product/new/typeRessource'
        }
        this.$http.post(url, data).then(response => {
            this.loading = false;
            this.dialogAjoutTypeRessource = false
            if (response.body.code == 3) {
                this.$message.error(response.body.message)
                return;
            }
            this.$notify({
              title: 'ENREGISTREMENT REUSSI',
              message: 'Type de ressrouce enregistré avec succès.',
              type: 'success',
              position: 'top-center'
          });
          this.loadTypeRessource()
        },
        error => {
            this.loading = false
            this.$message.error("Erreur lors de l'enregistrement du type projet ")

        })  
      },
      newProduit() {
        this.produitCourant.id = "";
        this.dialogAjoutProduit = true;
        this.codeType = ''
        this.dialogEditProduit = false;
        this.loadCodeGestion()
        this.typeProduit = "";
        this.codeGestion = ''
        this.formTypeProduit = {
          id: "",
          codeGestion: "",
          codeAnalytique:"",
          referenceProduit: "",
          libelleProduit: "",
          valeurProduit: 0,
          libelleUnite: "",
          descProduit: ""
        };
        this.tableTypeProduit = [];
      },
      newCategorie() {
        this.dialogAjoutCategory = true;
        this.dialogEditCategorie = false;
        this.idCategorie = "";
        this.libelleCategorie = "";
        this.descCategorie = "";
      },
      editTypeProjet(item) {
        this.typeProjetCourant = item;
        this.typeProjetSelect = item;
        this.showDialogTypeProjet = true;
      },
      editType(item,element) {
        this.typeLibelle = item.libelle;
        this.typeELement = element;
        this.typeCode = item.ordre
        this.typeDescription = item.code;
        this.editedType = item;
        this.dialogMofifTravaux = true;
      },  

      editTypeRessource(item) {
        this.typeLibelle = item.libelle;
        this.typeCode = item.code
        this.typeDescription = item.description;
        this.editedTypeRessource = item;
        this.dialogShowTypeRessource = false
        this.dialogAjoutTypeRessource = true;
      },
      editTache(item) {
        this.tacheCourant = item;
        this.dialogAjoutTache = true;
        this.dialogEdit = true;
        this.formTache.id = this.tacheCourant.id;
        this.formTache.ordre = this.tacheCourant.ordre;
        this.formTache.libelle = this.tacheCourant.libelle;
        this.formTache.unite = this.tacheCourant.unite;
        this.formTache.prix = this.tacheCourant.prix;

        this.typeProjet = this.tacheCourant.idTypeP;
        this.formTache.description = this.tacheCourant.description;
        this.loadTravaux();
        this.travaux = this.tacheCourant.idType;
      },
      editTravaux(item) {
        this.dialogAjoutTravaux = true;
        this.dialogEdit = true;
        this.travauxCourant = item;
        this.typeProjet = item.idType;
        this.formTravaux.id = item.id;
        this.formTravaux.libelle = item.libelle;
        this.formTravaux.ordre = item.ordre;
        this.formTravaux.description = item.description;
        this.formTravaux.code = item.code;
      },
      editProduit(item) {
        this.produitCourant = item;
        this.dialogAjoutProduit = true;
        this.dialogEditProduit = true;
        this.idProduit = item.id;
        this.referenceProduit = item.reference;
        this.libelleProduit = item.value;
        this.libelleUnite = item.unite;
        this.typeProduit = item.type;
        this.valeurProduit = item.valeur;
        this.descProduit = item.description;
        this.codeGestion = item.codeGestion

        this.formTypeProduit.valeurProduit = item.valeur;
        this.formTypeProduit.descProduit = item.description;
        this.formTypeProduit.referenceProduit = item.reference;
        this.formTypeProduit.codeAnalytique = item.codeAnalytique;
        this.formTypeProduit.libelleProduit = item.value;
        this.formTypeProduit.libelleUnite = item.unite;
      },
      editCategorie(item) {
        this.dialogAjoutCategory = true;
        this.dialogEditCategorie = true;
        this.idCategorie = item.id;
        this.libelleCategorie = item.libelle;
        this.descCategorie = item.description;
      },
      showTravaux(item) {
        this.dialogShowTravaux = true;
        this.travauxCourant = item;
      },
      addProduit() {
        this.loading = true;
        var form = document.getElementById("formProduit");
        let data = new FormData();

        let url = "";
        if (this.produitCourant.id) {
          url =
            this.domaine + "product/" + this.produitCourant.id + "/edit/product";
        } else {
          url = this.domaine + "product/create-product";
        }

        if (this.formTypeProduit.libelleProduit != "", this.typeProduit != "") {
          data.append("codeGestion", this.formTypeProduit.codeGestion);
          data.append("codeAnalytique", this.formTypeProduit.codeAnalytique);
          data.append("referenceProduit", this.formTypeProduit.referenceProduit);
          data.append("libelleProduit", this.formTypeProduit.libelleProduit);
          data.append("libelleUnite", this.formTypeProduit.libelleUnite);
          data.append("valeurProduit", this.formTypeProduit.valeurProduit);
          data.append("descProduit", JSON.stringify(this.formTypeProduit.descProduit));
          data.append("type", this.typeProduit);
          data.append("id", this.produitCourant.id);
          data.append("typePorduit", JSON.stringify(this.tableTypeProduit));
          data.append("idUser", this.user.id);

          this.$http.post(url, data).then(
            response => {
              this.loading = false;
              let verif = response.body;
              this.dialogShowProduit = false
              if (verif.code == 3) {
                this.$alert(verif.message, "Modification libelle ressource", {
                  confirmButtonText: "OK"
                });
                return;
              }
              this.dialogAjoutProduit = false;
              if (verif[0].code === 2) {
                this.$notify({
                  title: "ENREGISTREMENT PRODUIT",
                  message: verif.message,
                  type: "success",
                  position: "top-center"
                });
              }
              if (verif[0].code === 1) {
                this.$notify({
                  title: "MODIFICATION PRODUIT",
                  message: verif.message,
                  type: "success",
                  position: "top-center"
                });
              }
              this.loading = false;
              this.$refs.formProduit.reset();
              this.resitFOrmProduit();
              this.referenceProduit = "";
              this.tableTypeProduit = [];
              this.loadProduit();
            },
            response => {
              this.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
              this.loading = false;
            }
          );
        } else if (this.tableTypeProduit.length > 0) {

          data.append("type", this.typeProduit);
          data.append("id", this.produitCourant.id);
          data.append("typePorduit", JSON.stringify(this.tableTypeProduit));

          this.$http.post(url, data).then(response => {
            this.loading = false;
            this.dialogShowProduit = false
            let verif = response.body;
            if (verif[0].code === 3) {
              this.dialogAjoutProduit = true;
              this.$message.error(verif[0].message);
              this.libelleProduit = "";
            }
            this.dialogAjoutProduit = false;
            if (verif[0].code === 2) {
              this.$notify({
                title: "ENREGISTREMENT PRODUIT",
                message: verif.message,
                type: "success",
                position: "top-center"
              });
              this.$refs.formProduit.reset();
              this.resitFOrmProduit();
              this.referenceProduit = "";
              this.tableTypeProduit = [];
              this.loadProduit();
            }
            if (verif[0].code === 1) {
              this.$notify({
                title: "MODIFICATION PRODUIT",
                message: verif.message,
                type: "success",
                position: "top-center"
              });

              this.$refs.formProduit.reset();
              this.resitFOrmProduit();
              this.referenceProduit = "";
              this.tableTypeProduit = [];
              this.loadProduit();
            }
          });
        } else {
          this.$message.error("Veuillez compléter le formulaire correctement!");
          this.loading = false;
        }
        // }
      },
      addListTaches(item) {
        var input = document.getElementById("ordreTache");

        if (item.ordre == undefined || item.ordre == "") {
          this.tableTaches.push({
            libelle: item.libelle,
            ordre: input.value,
            unite: item.unite,
            prix: item.prix,
            description: item.description
          });
        } else {
          this.tableTaches.push({
            libelle: item.libelle,
            ordre: this.tableTaches.length + 1,
            unite: item.unite,
            prix: item.prix,
            description: item.description
          });
        }
        this.formTache = {
          ordre: this.tableTaches.length + 1
        };
      },
      resitFOrmProduit() {
        this.formTypeProduit.referenceProduit = "";
        this.formTypeProduit.valeurProduit = "";
        this.formTypeProduit.descProduit = "";
        this.formTypeProduit.libelleUnite = "";
        this.formTypeProduit.codeAnalytique = '';
        this.formTypeProduit.libelleProduit = "";
      },
      addListProduit(item) {
        this.tableTypeProduit.push({
          codeGestion: this.codeGestion,
          codeAnalytique: item.codeAnalytique,
          referenceProduit: item.referenceProduit,
          libelleProduit: item.libelleProduit,
          valeurProduit: item.valeurProduit,
          libelleUnite: item.libelleUnite,
          descProduit: item.descProduit
        });
        this.formTypeProduit.referenceProduit = "";
        this.formTypeProduit.codeAnalytique = '';
        this.codeGestion =''
        this.formTypeProduit.valeurProduit = "";
        this.formTypeProduit.descProduit = "";
        this.formTypeProduit.libelleUnite = "";
        this.formTypeProduit.libelleProduit = "";
      },

      addListParticipantDemande(item) {
        var input = document.getElementById("ordre");

        if (item.ordre == undefined || item.ordre == "") {
          this.tableLots.push({
            id: item.code++,
            libelle: item.libelle,
            code: item.code,
            ordre: input.value,
            description: item.description
          });
        } else {
          this.tableLots.push({
            id: this.tableLots.length + 1,
            libelle: item.libelle,
            code: item.code,
            ordre: this.tableLots.length + 1,
            description: item.description
          });
        }
        this.formTravaux = {
          ordre: this.tableLots.length + 1
        };
      },
      addCategorie() {
        if (this.$refs.formCategorie.validate()) {
          var form = document.getElementById("formCategorie");
          var data = new FormData(form);
          let url = "";
          if (this.idCategorie) {
            url = this.domaine + "keyword/update-familly/" + this.idCategorie;
          } else {
            url = this.domaine + "keyword/create-familly";
          }
          this.$http.post(url, data).then(
            response => {
              if (response.body) {
                let verif = response.body;
                if (verif.code === 2) {
                  if (this.idCategorie) {
                    this.$notify({
                      title: "MODIFICATION REUSSI",
                      message: "Catégorie enregistré avec succès.",
                      type: "success",
                      position: "top-center"
                    });
                  } else {
                    this.$notify({
                      title: "ENREGISTREMENT REUSSI",
                      message: "Catégorie enregistré avec succès.",
                      type: "success",
                      position: "top-center"
                    });
                  }
                  this.dialogAjoutCategory = false;
                } else if (verif.code === 1) {
                  this.dialogAjoutCategory = true;
                  this.$message.error(verif.message);
                }
              } else {
                this.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
                this.loading = false;
              }
            },
            response => {
              this.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
              this.loading = false;
            }
          );
        }
      },
      generateFileExcel() {
        let url = this.domaine + "projet/generer/modele/produits";
        window.open(url);
      },
      onFileExcelPicked(event) {
        this.fileExcel.splice(0, 1);
        const files = event.target.files;
        let filename = files[0].name;
        if (filename.lastIndexOf(".xls") <= 0) {
          return alert("Veuillez selectionner un fichier excel valide ");
        }
        if (files[0].size > 1048576) {
          this.$message.error("La taille du fichier est supérieur à 1024 ko");
          return;
        }
        const fileReader = new FileReader();
        fileReader.addEventListener("load", () => {
          this.fileExcel.push(fileReader.result);
        });
        fileReader.readAsDataURL(files[0]);
        let url = this.domaine + "projet/loadProduit/excel";
        let data = new FormData();
        data.append("fichierExcel", files[0], files[0][name]);
        this.$http.post(url, data).then(
          resp => {
            this.loading = false;

            this.$notify({
              title: "Chargement liste des ressources",
              message: "Chargement effectué",
              type: "success",
              position: "top-right",
              duration: 7000
            });
            this.lstTypeTravaux = resp.body.listeTypeTravaux;
            this.showModalLoadTypeTravaux = true;
          },
          resp => {
            this.loading = false;
            this.$message.error("Erreur lors de l'importation du fichier");
          }
        );
      },
      filtrerEtatPrioriteBesoin() {
        this.listeProduitAffich = this.listeProduitAffich.filter(element => {
          this.loading = false;
          return element.value == this.IdProduiSelect;
        });
      },
      submitTache() {
        this.loading = true;
        if (
          this.$refs.formTache.validate() &&
          this.travaux != "" &&
          this.formTache.libelle != "" &&
          this.formTache.ordre != 0
        ) {
          var form = document.getElementById("formTache");
          var data = new FormData(form);
          let url = "";
          if (this.tacheCourant.id) {
            url =
              this.domaine +
              "projet/" +
              this.tacheCourant.id +
              "/edit/tache/projet";
          } else {
            url = this.domaine + "projet/new/tache/projet";
          }

          data.append("id", this.formTache.id);
          data.append("travaux", this.travaux);
          data.append("idUser", this.user.id);
          data.append("tache", JSON.stringify(this.tableTaches));
          data.append("formTache", JSON.stringify(this.formTache));

          this.$http.post(url, data).then(
            response => {
              if (response.body) {
                let verif = response.body;
                if (verif.code === 3) {
                  // this.dialogAjoutTache = true
                  this.$message.error(verif.message);
                  // this.libelleProduit =""
                }
                if (verif.code === 1) {
                  this.$notify({
                    title: "ENREGISTREMENT REUSSI",
                    message: "Tâche enregistré avec succès.",
                    type: "success",
                    position: "top-center"
                  });
                  this.loading = false;
                  this.dialogAjoutTache = false;
                  this.tableTaches = [];
                  this.formTache = {};
                  this.loadTypeProjet();
                  this.loadTache();
                } else {
                  this.$message.error(verif.message);
                  this.loading = false;
                }
              } else {
                this.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
                this.loading = false;
              }
            },
            response => {
              this.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
              this.loading = false;
            }
          );
        } else {
          this.$message.error("Veuillez renseigner les champs obligatoires");
          this.$notify.error({
            title: "ERREUR D'ENREGISTREMENT",
            message: "La tâche n'a pas été enregistré.",
            position: "top-center"
          });
          this.loading = false;
        }
      },
      closeShowProdui() {
        this.dialogShowProduit = false;        
        this.handleTabClick1(4)
      },
      submitTravaux() {
        this.loading = true;
        if (
          this.$refs.formTravaux.validate() &&
          this.tableLots != [] &&
          this.typeProjet != ""
        ) {
          var form = document.getElementById("formTravaux");
          var data = new FormData(form);
          let url = "";
          if (this.travauxCourant.id) {
            url =
              this.domaine +
              "projet/" +
              this.travauxCourant.id +
              "/edit/travaux/projet";
          } else {
            url = this.domaine + "projet/new/travaux/projet";
          }
          data.append("formTravaux", this.formTravaux);
          data.append("id", this.formTravaux.id);
          data.append("type", this.typeProjet);
          data.append("idUser", this.user.id);
          data.append("lots", JSON.stringify(this.tableLots));
          data.append("formTravaux", JSON.stringify(this.formTravaux));

          this.$http.post(url, data).then(
            response => {
              if (response.body) {
                let verif = response.body;
                if (verif.code == 3) {
                  this.loading = false;
                  this.$message.error(verif.message);
                }
                if (verif.code == 1) {
                  this.$notify({
                    title: "ENREGISTREMENT REUSSI",
                    message: "Lot enregistré avec succès.",
                    type: "success",
                    position: "top-center"
                  });

                  this.loading = false;
                  this.dialogAjoutTravaux = false;
                  //this.loadAllTravaux()
                } else {
                  this.loading = false;
                  this.$message.error(verif.message);
                }
              } else {
                this.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
                this.loading = false;
              }
            },
            response => {
              this.$message.error("Une erreur est survenue. Veuillez contacter votre administrateur");
              this.loading = false;
            }
          );
        } else {
          this.$message.error("Veuillez renseigner les champs obligatoires");
          this.$notify.error({
            title: "ERREUR D'ENREGISTREMENT",
            message: "Le type travaux n'a pas été enregistré.",
            position: "top-center"
          });
          this.loading = false;
        }
      },
      removeKeyword(item) {
        this.dialogSuprKeyword = true;
        this.idProduit = item.id;
      },
      removeLexique(item) {
        this.dialogSuprLexique = true;
        this.idLexique = item.id;
      },
      removeCategorie(item) {
        this.dialogSuprCategorie = true;
        this.idCategorie = item.id;
      },
      deleteType() {
        this.loading = true;
        let url = this.domaine + "projet/" + this.idAppro + "/delete/type";
        this.$http.get(url).then(response => {
          this.loading = false;
          if (response.body.code == 3) {
            this.$alert(response.body.message, "Suppresion type Chantier", {
              confirmButtonText: "OK"
            });
            this.dialogSuprTyp = false;
            return;
          }

          if (response.body) {
            let verif = response.body;
            if (verif.code === 1) {
              this.$notify({
                title: "SUPPRESSION",
                message: "Enregistrement supprimé avec succès.",
                type: "success",
                position: "top-center"
              });
            } else if (verif.code === 2) {
              this.$notify({
                title: "SUPPRESSION",
                message: verif.message,
                type: "warning",
                position: "top-center"
              });
            }
            this.dialogSuprTyp = false;
            this.loadTypeProjet();
          }
        });
      },
      clearSelectProduit() {
        this.loadProduit();
      },
      deleteLots() {
        let url = this.domaine + "projet/" + this.idAppro + "/lot/delete";
        this.$http.get(url).then(response => {
          if (response.body) {
            let verif = response.body;
            if (verif.code === 1) {
              this.$notify({
                title: "SUPPRESSION",
                message: "e supprimé avec succès.",
                type: "success",
                position: "top-center"
              });
            } else if (verif.code === 2) {
              this.$notify({
                title: "SUPPRESSION",
                message: verif.message,
                type: "warning",
                position: "top-center"
              });
            }
            this.dialogSuprLots = false;
            //this.loadAllTravaux()
          }
        });
      },
      deleteTaches() {
        let url =
          this.domaine + "projet/" + this.idAppro + "/delete/tache/projet";
        this.$http.get(url).then(response => {
          if (response.body) {
            let verif = response.body;
            if (verif.code === 1) {
              this.$notify({
                title: "SUPPRESSION",
                message: "Tache supprimé avec succès.",
                type: "success",
                position: "top-center"
              });
            } else if (verif.code === 2) {
              this.$notify({
                title: "SUPPRESSION",
                message: verif.message,
                type: "warning",
                position: "top-center"
              });
            }
            this.dialogSuprTache = false;
            this.loadTypeProjet();
            this.loadTache();
          }
        });
      },
      deleteTypeProd() {
          this.loading = true;
        let url = this.domaine + "product/delete-product/" + this.idAppro;
        this.$http.get(url).then(response => {
          if (response.body) {
            let verif = response.body;
            if (verif.code === 1) {
                this.loading = false;
              this.$notify({
                title: "SUPPRESSION",
                message: "Approvisionnement supprimé avec succès.",
                type: "success",
                position: "top-center"
              });
            } else if (verif.code === 2) {
              this.loading = false;
              this.$notify({
                title: "SUPPRESSION",
                message: verif.message,
                type: "warning",
                position: "top-center"
              });
            }
            this.loading = false;
            this.dialogSuprProd = false;
            }
            this.loading = false;
            this.dialogSuprProd = false
            this.dialogSuprAppro = false;
            this.loadProduit();
          });
      }
    },
    mounted () {
      this.loadTypeProjet()
      this.loadProduit()
      this.loadTypeRessource()
    },
  };
</script>



// WEBPACK FOOTER //
// src/components/Keywords.vue